<div class="panel-loader" *ngIf="isInitialLoading">
  <div class="loader-box fancy">
    <div class="brand-row">
      <div class="logo">
        <img src="assets/azeapp.png" alt="AzeApp Logo" class="logo-image" />
      </div>
      <div class="orbit">
        <div class="core"></div>
        <div class="ring r1"></div>
        <div class="ring r2"></div>
        <div class="dot d1"></div>
        <div class="dot d2"></div>
        <div class="dot d3"></div>
      </div>
    </div>

    <div class="tip">{{ loaderTips[loaderTipIndex] }}…</div>

    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="loaderProgress"></div>
    </div>

    <div class="skeleton-grid">
      <div class="sk sk-h1"></div>
      <div class="sk sk-h2"></div>
      <div class="sk sk-h3"></div>
      <div class="sk sk-r1"></div>
      <div class="sk sk-r2"></div>
      <div class="sk sk-r3"></div>
      <div class="sk sk-r4"></div>
      <div class="sk sk-r5"></div>
      <div class="sk sk-r6"></div>
    </div>
  </div>
</div>

<div class="enquiry-details-page" *ngIf="!isInitialLoading">
  <!-- Header -->
  <header class="page-header">
    <div class="header-toolbar">
      <button class="back-button" (click)="router.navigate(['/dashboard'])">
        <i class="fas fa-arrow-left"></i>
      </button>

      <ng-container *ngIf="orderAvailable">
        <h1 class="page-title">Enquiry Details - {{ enquiry?.branchName }}</h1>
        <button
          class="query-button"
          title="Click to Make query"
          (click)="showQueryModal = true"
          *ngIf="
            enquiry?.statusDescription == 'New Enquiry' ||
            (enquiry?.statusDescription == 'Additional info required' &&
              accType == '2')
          "
        >
          <i class="fas fa-info-circle"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="!orderAvailable">
        <h1 class="page-title">Enquiry Details</h1>
      </ng-container>
    </div>
  </header>

  <div class="enquiry-detail-container" *ngIf="!showErrorBanner">
    <div class="auth">
      <ng-container *ngIf="orderAvailable">
        <ng-container *ngIf="enquiry!">
          <form class="form">

            <div class="section vehicleDetails">
              <div class="section-header">
                <i class="fas fa-car"></i>
                <h2>Vehicle Details</h2>
              </div>


              <ng-container *ngIf="basicDetails?.enquiryDetails?.isBulkupload == 1; else vehicleDetailsBlock">
                  <div class="details-grid">
                    <div class="detail-item d-flex flex-column align-items-start" *ngIf="accType == '2'">
                      <label class="mb-2" style="font-size: 1.1rem; color: #333; font-weight: 500;">
                        <i class="fas fa-user me-2 text-success"></i> Name
                      </label>
                      <span class="badge bg-primary text-light px-4 py-2" style="font-size: 1.2rem; font-weight: 600; letter-spacing: 1px;">
                        {{ basicDetails?.enquiryDetails?.username || "-" }}
                      </span>
                    </div>

                    <div class="detail-item d-flex flex-column align-items-start">
                      <label class="mb-2" style="font-size: 1.1rem; color: #333; font-weight: 500;">
                        <i class="fas fa-car me-2 text-success"></i> Make
                      </label>
                      <span class="badge bg-primary text-light px-4 py-2" style="font-size: 1.5rem; font-weight: bold; letter-spacing: 2px;">
                        {{ basicDetails?.enquiryDetails?.make || "-" }}
                      </span>
                    </div>
                  </div>
                </ng-container>

              <ng-template #vehicleDetailsBlock>
                  <div class="details-grid">
                    <!-- Vehicle No -->
                    <!-- <div class="detail-item">
                      <label>Vehicle No</label>
                      <span>{{ basicDetails?.enquiryDetails?.vehNo || "-" }}</span>
                    </div>

                    <div class="detail-item">
                      <label>Chassis No</label>
                      <span>{{ basicDetails?.enquiryDetails?.chassisNo || "-" }}</span>
                    </div> -->
                    <!-- Make -->
                    <div class="detail-item"  *ngIf="accType == '2'">
                      <label>Name</label>
                      <span>{{ basicDetails?.enquiryDetails?.username || "-" }}</span>
                    </div>
                    <div class="detail-item">
                      <label>Make</label>
                      <span>{{ basicDetails?.enquiryDetails?.make || "-" }}</span>
                    </div>
                    <!-- Model -->
                    <div class="detail-item">
                      <label>Model</label>
                      <span>{{ basicDetails?.enquiryDetails?.model || "-" }}</span>
                    </div>
                    <!-- Fuel Type -->
                    <div class="detail-item">
                      <label>Fuel Type</label>
                      <span>{{ basicDetails?.enquiryDetails?.fuelType || "-" }}</span>
                    </div>
                    <!-- Transmission Type -->
                    <div class="detail-item">
                      <label>Transmission Type</label>
                      <span>{{ basicDetails?.enquiryDetails?.transmissionType || "-" }}</span>
                    </div>
                    <!-- Reg Date -->
                    <div class="detail-item">
                      <label>Reg Date</label>
                      <span>{{ basicDetails?.enquiryDetails?.regDate || "-" }}</span>
                    </div>
                    <!-- Variant -->
                    <div class="detail-item">
                      <label>Variant</label>
                      <span>{{ basicDetails?.enquiryDetails?.variant || "-" }}</span>
                    </div>
                    <!-- Reg No -->
                    <div class="detail-item" *ngIf="basicDetails?.enquiryDetails?.vehNo">
                      <label>Reg No</label>
                      <span>{{ basicDetails?.enquiryDetails?.vehNo || "-" }}</span>
                    </div>
                    <!-- Chassis No -->
                    <div class="detail-item" *ngIf="basicDetails?.enquiryDetails?.chassisNo">
                      <label>Chassis No</label>
                      <span>{{ basicDetails?.enquiryDetails?.chassisNo || "-" }}</span>
                    </div>
                    <!-- Color -->
                    <div class="detail-item" *ngIf="basicDetails?.enquiryDetails?.color">
                      <label>Color</label>
                      <span>{{ basicDetails?.enquiryDetails?.color || "-" }}</span>
                    </div>
                  </div>

              <!-- Vehicle Attachments Section -->
              <div
                class="attachment-section"
                *ngIf="
                  accType == '1' &&
                  (enquiry?.statusDescription == 'Estimate received' ||
                    enquiry?.statusDescription == 'Additional info required')
                "
              >
                <div class="attachment-header">
                  <select
                    class="attachment-type-select"
                    (change)="onUploadVehDocTypeChange($event)"
                  >
                    <option value="">Select Document Type</option>
                    <option
                      *ngFor="let item of vehicleDocList"
                      [value]="item.id"
                    >
                      {{ item.value }}
                    </option>
                  </select>
                  <button
                    class="upload-button"
                    type="button"
                    (click)="newVehicleAttachment()"
                  >
                    Upload
                  </button>
                </div>
              </div>

              <!-- Vehicle Attachment List -->
              <div
                class="attachment-section"
                *ngIf="
                  this.basicDetails?.enquiryDetails?.attachments?.length > 0 ||
                  vehicleAttachmentList.length > 0
                "
              >
                <table
                  class="attachment-table"
                  *ngIf="vehicleAttachmentList.length > 0"
                >
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Option</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let attachment of vehicleAttachmentList;
                        let i = index
                      "
                    >
                      <td>
                        {{ getAttachmentValue(attachment.attachmentType) }}
                      </td>
                      <td class="actions">
                        <button
                          type="button"
                          class="icon-button"
                          (click)="showVehicleAttachment(i, attachment)"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                        <button
                          type="button"
                          class="icon-button delete"
                          *ngIf="
                            accType == '1' &&
                            (enquiry?.statusDescription ==
                              'Estimate received' ||
                              enquiry?.statusDescription ==
                                'Additional info required')
                          "
                          (click)="
                            removeVehicleAttachment(i, attachment.attachmentId)
                          "
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              </ng-template>


            </div>
          </form>

          <form class="form" [formGroup]="registerForm">
            <!-- Part Details Section -->
            <div
              class="section partDetails"
              *ngIf="
                ![
                  'Order Placed',
                  'Pending for invoice',
                  'Billed/intrasit',
                  'Billed/Delivered',
                  'Return Raised',
                  'Pending For Return Approval',
                  'Return Approved',
                  'Pickup in progress',
                  'Pending For POD Approval',
                  'Dispatch Confirmation Pending'
                ].includes(enquiry?.statusDescription)
              "
            >
              <div class="section-header d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                  <i class="fas fa-cogs"></i>
                  <h2>Part Details</h2>
                </div>
                <ng-container *ngIf="basicDetails?.enquiryDetails?.isBulkupload === 1 && basicDetails?.enquiryDetails?.excelExport?.url && (
                  enquiry?.statusDescription === 'Estimate received' ||
                  enquiry?.statusDescription === 'Estimate Sent' ||
                  enquiry?.statusDescription === 'Estimate Partially Received' ||
                  enquiry?.statusDescription === 'Estimate Partially Sent')">
                  <a class="btn btn-success px-4 py-2 d-flex align-items-center gap-2"
                     [href]="basicDetails?.enquiryDetails?.excelExport?.url"
                     target="_blank"
                     download
                     style="font-weight: 500; font-size: 1rem;">
                    <i class="fas fa-download" style="color: #fff;font-size: 1rem;"></i>
                    Download Excel
                  </a>
                </ng-container>
              </div>

              <ng-container
                *ngIf="
                  basicDetails?.enquiryDetails?.isBulkupload === 1;
                  else manualEntryBlock
                "
              >
                  <ng-container
                    *ngIf="
                      enquiry?.statusDescription === 'Estimate received' ||
                      enquiry?.statusDescription === 'Estimate Sent' || 
                      enquiry?.statusDescription === 'Estimate Partially Received' ||
                      enquiry?.statusDescription === 'Estimate Partially Sent' ||
                      (enquiry?.statusDescription !== 'Estimate received' &&
                        enquiry?.statusDescription !== 'Estimate Sent' &&
                        enquiry?.statusDescription !== 'Estimate Partially Received' &&
                        enquiry?.statusDescription !== 'Estimate Partially Sent' &&
                        enquiry?.statusDescription !== 'New Enquiry' &&
                        enquiry?.statusDescription !== 'Additional info required')
                    "
                  >
                <!-- Sort Toggle Segment -->
                <!-- <div 
                  class="sort-toggle d-flex justify-content-end pe-3" 
                  *ngIf="enquiry?.statusDescription === 'Estimate received'"
                >
                  <div class="btn-group" role="group" style="width: auto;">
                    <input 
                      type="radio" 
                      class="btn-check" 
                      name="reqType" 
                      id="bestPrice" 
                      value="1"
                      [(ngModel)]="reqType"
                      [ngModelOptions]="{standalone: true}"
                      (change)="confirmSortChange($event)"
                    >
                    <label class="btn btn-outline-primary" for="bestPrice">
                      <i class="fas fa-dollar-sign me-2"></i>
                      Best Price
                    </label>

                    <input 
                      type="radio" 
                      class="btn-check" 
                      name="reqType" 
                      id="fastDelivery" 
                      value="2"
                      [(ngModel)]="reqType"
                      [ngModelOptions]="{standalone: true}"
                      (change)="confirmSortChange($event)"
                    >
                    <label class="btn btn-outline-primary" for="fastDelivery">
                      <i class="fas fa-shipping-fast me-2"></i>
                      Fast Delivery
                    </label>
                  </div>
                </div> -->
                <div class="grid-container">
                    <!-- Header Row -->
                    <div class="row header-row">
                      <div class="col col-3 header-col">Part No</div>
                      <div class="col col-4 header-col">Description</div>
                      <div class="col col-2 header-col">Qty</div>
                      <div class="col col-3 header-col">Option</div>
                    </div>

                    <!-- Parts Loop -->
                    <ng-container
                      *ngFor="
                        let part of basicDetails?.enquiryDetails?.partDetails;
                        let partIndex = index
                      "
                    >
                      <div
                        class="row part-row"
                        *ngIf="
                          ((enquiry?.statusDescription ===
                            'Estimate received' ||
                            enquiry?.statusDescription === 'Estimate Sent' ||
                            enquiry?.statusDescription === 'Estimate Partially Received' ||
                            enquiry?.statusDescription === 'Estimate Partially Sent') &&
                            part?.priceDetails?.length > 0 &&
                            !part?.brand) ||
                          (enquiry?.statusDescription !== 'Estimate received' &&
                            enquiry?.statusDescription !== 'Estimate Sent' &&
                            enquiry?.statusDescription !== 'Estimate Partially Received' &&
                            enquiry?.statusDescription !== 'Estimate Partially Sent')
                        "
                      >
                        <!-- Part No -->
                        <div class="col col-3">
                          <ng-container *ngIf="part?.partNo; else editPartNo">
                            <span class="highlight medium">{{
                              part?.partNo
                            }}</span>
                          </ng-container>
                          <ng-template #editPartNo>
                            <input
                              type="text"
                              placeholder="Enter Part No"
                              (change)="onPartNoChange($event, part)"
                              class="custom-input"
                            />
                          </ng-template>
                        </div>

                        <!-- Description -->
                        <div class="col col-4">
                          <span class="highlight large">{{
                            part?.partDescription
                          }}</span>
                        </div>

                        <!-- Quantity -->
                        <div class="col col-2">
                          <span class="highlight small">{{ part?.qty }}</span>
                        </div>                       
                        
                        <!-- Image Icon -->
                        <div class="col col-3">
                          <button
                            class="btn btn-link p-0"
                            [disabled]="!part?.url"
                            (click)="
                              part.url &&
                                showPartDetailsAttachment(partIndex, part)
                            "
                            [ngClass]="{
                              'text-primary': part.url,
                              'text-muted': !part.url
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                        </div>

                    <!-- Price Section: Estimate received/Sent -->
                      <ng-container
                        *ngIf="
                          enquiry?.statusDescription === 'Estimate received' ||
                          enquiry?.statusDescription === 'Estimate Sent' ||
                          enquiry?.statusDescription === 'Additional info required' ||
                          enquiry?.statusDescription === 'Estimate Partially Received' ||
                          enquiry?.statusDescription === 'Estimate Partially Sent'
                        "
                      >

                        <div
                          class="col col-6 available-qty-col"
                          *ngIf="
                            accType == '1' &&
                            enquiry?.statusDescription === 'Estimate received' &&
                            part?.availableQtyMessage
                          "
                        >
                          <span class="available-qty-message">
                            <i class="fas fa-info-circle"></i>
                            {{ part?.availableQtyMessage }}
                          </span>
                        </div>

                        <div
                          class="col col-6 right-align"
                          *ngIf="part?.priceDetails?.length > 0 && !part?.brand && part?.partNo"
                        >
                          <div class="grid-sub">
                            <div class="row header-row">
                              <!-- <div class="col col-5 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price(INC GST)
                              </div>
                              <div class="col col-3 header-col">Option</div> -->
                              <div class="col col-4 header-col">Brand</div>
                              <div class="col col-3 header-col">Billing Price(INC GST)</div>
                              <div class="col col-3 header-col">Delivery Time</div>
                              <div class="col col-2 header-col">Option</div>
                            </div>
                            <div
                              class="row"
                              *ngFor="let price of getSortedPriceDetails(part)"
                            >
                              <div class="col col-4">{{ price?.brand }}</div>
                              <!-- <div class="col col-4">{{ price?.price }}</div> -->

                              <div
                                class="col col-3"
                                *ngIf="
                                  accType == '1' &&
                                  (enquiry?.statusDescription ==
                                    'Estimate received' ||
                                    enquiry?.statusDescription ==
                                      'Additional info required' ||
                                    enquiry?.statusDescription ==
                                      'Estimate Partially Received')
                                "
                              >
                                <div class="price-stack">
                                  <div class="offer-line">
                                    <span class="offer-price">
                                      {{
                                        price?.sellingPrice ?? price?.price
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-1"
                                      }}
                                    </span>
                                    <span
                                      class="off-badge"
                                      *ngIf="
                                        price?.price &&
                                        price?.sellingPrice &&
                                        price?.price > price?.sellingPrice
                                      "
                                    >
                                      {{
                                        getDiscount(
                                          price?.price,
                                          price?.sellingPrice
                                        )
                                      }}% OFF
                                    </span>
                                  </div>
                                  <div
                                    class="mrp-line"
                                    *ngIf="price?.price && price?.sellingPrice && price?.price > price?.sellingPrice"
                                  >
                                    <span class="mrp"
                                      >MRP
                                      {{
                                        price?.price
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-0"
                                      }}</span
                                    >
                                    <span
                                      *ngIf="price?.price > price?.sellingPrice"
                                      class="save-amt"
                                      >You save
                                      {{
                                        getSave(
                                          price?.price,
                                          price?.sellingPrice
                                        )
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-1"
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>

                              <div
                                class="col col-3"
                                *ngIf="
                                  accType == '2' &&
                                  (enquiry?.statusDescription == 'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent')
                                "
                              >
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{
                                          price?.landingPrice ?? price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      class="mrp-line"
                                      *ngIf="price?.price && price?.landingPrice && price?.price > price?.landingPrice"
                                    >
                                      <span class="mrp"
                                        >MRP
                                        {{
                                          price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}</span
                                      >
                                    </div>
                                    
                                  </div>
                              </div>

                               <!-- New Delivery Time Column -->
                              <div class="col col-3">
                                <span class="badge bg-info text-dark">
                                  <i class="fas fa-shipping-fast me-1"></i>
                                  {{ getDeliveryTimeLabel(price?.deliveryTime) }}
                                </span>
                              </div>
                              <div class="col col-2">
                                <ng-container
                                  *ngIf="
                                    enquiry?.statusDescription ==
                                    'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent'
                                  "
                                  >-</ng-container
                                >
                                <ng-container
                                  *ngIf="
                                    enquiry?.statusDescription ==
                                      'Estimate received' ||
                                    (enquiry?.statusDescription ==
                                      'Additional info required' &&
                                      accType === '1' ) ||
                                    (enquiry?.statusDescription ==
                                      'Estimate Partially Received' &&
                                    accType === '1' )
                                  "
                                >
                                  <input
                                    type="checkbox"
                                    [checked]="
                                      isSelected(
                                        part?.enquiryPartId,
                                        price.brand
                                      )
                                    "
                                    [disabled]="
                                      selectedGlobalSellerId !== null &&
                                      selectedGlobalSellerId !== price.sellerId
                                    "
                                    (change)="
                                      onCheckboxChange(
                                        part?.enquiryPartId,
                                        price,
                                        part.qty,
                                        $event
                                      )
                                    "
                                  />
                                </ng-container>
                              </div>

                              <!-- Attractive Branch Name Display, right aligned -->
                              <div *ngIf="price?.branchName && accType == '2'" class="d-flex justify-content-end align-items-center mt-2">
                                <span class="badge bg-branch text-light px-4 py-2 shadow" style="font-size: 0.9rem; font-weight: 500; letter-spacing: 1px; border-radius: 1.5rem;">
                                  <i class="fas fa-map-marker-alt me-2"></i>
                                  Branch: {{ price.branchName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Selected Brand -->
                        <div class="col col-6 right-align" *ngIf="part?.brand">
                          <div class="grid-sub">
                            <div class="row header-row">
                              <!-- <div class="col col-5 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price(INC GST)
                              </div>
                              <div class="col col-3 header-col">Option</div> -->
                              <div class="col col-4 header-col">Brand</div>
                              <div class="col col-3 header-col">Billing Price(INC GST)</div>
                              <div class="col col-3 header-col">Delivery Time</div>
                              <div class="col col-2 header-col">Option</div>
                            </div>
                            <div class="row">
                              <div class="col col-4">{{ part?.brand }}</div>
                              <div class="col col-3" *ngIf="accType == '1' && (enquiry?.statusDescription == 'Estimate received'|| enquiry?.statusDescription == 'Additional info required' || enquiry?.statusDescription == 'Estimate Partially Received')">
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{ part?.sellingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                      </span>
                                      <span class="off-badge" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                                        {{ getDiscount(part?.price, part?.sellingPrice) }}% OFF
                                      </span>
                                    </div>
                                    <div class="mrp-line" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                                      <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>  
                                      <span *ngIf="part?.price > part?.sellingPrice"
                                        class="save-amt">You save {{ getSave(part?.price, part?.sellingPrice) | currency:'INR':'symbol':'1.0-1' }}</span>
                                    </div>
                                  </div>
                              </div>

                                <div class="col col-3" *ngIf="accType == '2' && (enquiry?.statusDescription == 'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent')">
                                    <div class="price-stack">
                                      <div class="offer-line">
                                        <span class="offer-price">
                                          {{ part?.landingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                        </span>
                                      </div>
                                      <div class="mrp-line" *ngIf="part?.price && part?.landingPrice">
                                        <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>
                                      </div>
                                    </div>
                                </div>

                                <!-- New Delivery Time Column -->
                                <div class="col col-3">
                                  <span class="badge bg-info text-dark">
                                    <i class="fas fa-shipping-fast me-1"></i>
                                    {{ getDeliveryTimeLabel(part?.deliveryTime) }}
                                  </span>
                                </div>
                              <div class="col col-3">-</div>

                             <!-- Attractive Branch Name Display, right aligned -->
                              <div *ngIf="part?.branchName && accType == '2'" class="d-flex justify-content-end align-items-center mt-2">
                                <span class="badge bg-branch text-light px-4 py-2 shadow" style="font-size: 0.9rem; font-weight: 500; letter-spacing: 1px; border-radius: 1.5rem;">
                                  <i class="fas fa-map-marker-alt me-2"></i>
                                  Branch: {{ part.branchName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="accType == '1' && !part?.partNo">
                        <div class="stock-not-available-msg text-end py-1 pe-3">
                          <span class="badge bg-warning text-dark">
                            <i class="fas fa-exclamation-circle me-1"></i>
                            Stock not available
                          </span>
                        </div>
                      </ng-container>

                      <!-- Verification Status -->
                      <div class="col-12 text-end mt-2 mb-1 pe-3" *ngIf="part?.verificationStatus">
                        <span class="badge" [ngClass]="{
                          'bg-warning text-dark': part.verificationStatus === 'pending',
                          'bg-success': part.verificationStatus === 'verified',
                          'bg-danger': part.verificationStatus === 'rejected'
                        }">
                          Verification: {{ part.verificationStatus | titlecase }}
                        </span>
                      </div>
                      
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="
                    enquiry?.statusDescription === 'New Enquiry' ||
                    enquiry?.statusDescription === 'Additional info required'
                  "
                >
                  @if(accType == '2'){
                  <div class="m-3">
                    <h5 class="text-dark mb-2">
                      📥 Step 1: Download Enquiry in Excel Template
                    </h5>
                    <p class="text-muted mb-3">
                      Download the preformatted Excel sheet for adding parts
                      Price details.
                    </p>
                    <button
                      class="btn btn-outline-primary px-4 py-2"
                      (click)="downloadEnqTemplate()"
                      [disabled]="templateDownloaded"
                    >
                      <i class="fas fa-download me-2"></i>Download Enquiry
                    </button>
                  </div>

                  <!-- Step 2: Upload Filled Template -->
                  <div *ngIf="templateDownloaded" class="m-3 border-top pt-4">
                    <h5 class="text-dark mb-2">
                      📤 Step 2: Upload Excel with Prices
                    </h5>
                    <p class="text-muted mb-3">
                      Fill the Price Details in downloaded template, then upload
                      it back here.
                    </p>

                    <!-- Hidden File Input -->
                    <input
                      #excelFileInput
                      type="file"
                      accept=".xlsx, .xls, .csv"
                      class="d-none"
                      (change)="handleFileChange($event)"
                    />

                    <!-- Select File Button -->
                    <button
                      class="btn btn-outline-secondary me-3"
                      (click)="excelFileInput.click()"
                    >
                      <i class="fas fa-folder-open me-2"></i>Select Excel File
                    </button>

                    <!-- Upload Button -->
                    <button
                      class="btn btn-success"
                      (click)="onExcelUpload()"
                      [disabled]="!selectedExcelFile"
                    >
                      <i class="fas fa-upload me-2"></i>Upload
                    </button>

                    <!-- File Preview and Remove -->
                    <div
                      *ngIf="selectedExcelFile"
                      class="mt-3 d-flex align-items-center gap-3"
                    >
                      <span class="badge bg-secondary">
                        <i class="fas fa-file-excel me-1"></i
                        >{{ selectedExcelFile.name }}
                      </span>

                      <button
                        class="btn btn-link text-danger p-0 text-start"
                        (click)="clearSelectedExcelFile()"
                        type="button"
                        title="Remove selected file"
                      >
                        <i class="fas fa-times-circle fa-lg"></i>
                      </button>
                    </div>
                  </div>

                  <div class="grid-container">
                    <!-- Header Row -->
                    <div class="row header-row">
                      <div class="col col-3 header-col">Part No</div>
                      <div class="col col-4 header-col">Description</div>
                      <div class="col col-2 header-col">Qty</div>
                      <div class="col col-3 header-col">Image</div>
                    </div>

                    <!-- Parts Loop -->
                    <ng-container
                      *ngFor="
                        let part of basicDetails?.enquiryDetails?.partDetails;
                        let partIndex = index
                      "
                    >
                      <div class="row part-row">
                        <!-- Part No -->
                        <div class="col col-3">
                           <span class="highlight medium">{{
                              part?.partNo || '-'
                            }}</span>
                          <!-- <ng-container *ngIf="part?.partNo; else editPartNo">
                            <span class="highlight medium">{{
                              part?.partNo
                            }}</span>
                          </ng-container>
                          <ng-template #editPartNo>
                            <input
                              type="text"
                              placeholder="Enter Part No"
                              (change)="onPartNoChange($event, part)"
                              class="custom-input"
                            />
                          </ng-template> -->
                        </div>

                        <!-- Description -->
                        <div class="col col-4">
                          <span class="highlight large">{{
                            part?.partDescription
                          }}</span>
                        </div>

                        <!-- Quantity -->
                        <div class="col col-2">
                          <span class="highlight small">{{ part?.qty }}</span>
                        </div>

                        <!-- Image Icon -->
                        <div class="col col-3">
                          <button
                            class="btn btn-link p-0"
                            [disabled]="!part?.url"
                            (click)="
                              part.url &&
                                showPartDetailsAttachment(partIndex, part)
                            "
                            [ngClass]="{
                              'text-primary': part.url,
                              'text-muted': !part.url
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </button>
                        </div>

                        <!-- <div class="col col-6 right-align">
                          <div class="grid-sub">
                            <div class="row header-row">
                              <div class="col col-8 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price(INC GST)
                              </div>
                            </div>
                            <div
                              class="row"
                              *ngIf="
                                part?.oe &&
                                (basicDetails?.enquiryDetails?.partType ==
                                  '1' ||
                                  basicDetails?.enquiryDetails?.partType == '2')
                              "
                            >
                              <div class="col col-8">
                                {{ basicDetails?.enquiryDetails?.make || "-" }}
                              </div>
                              <div class="col col-4">
                                <input
                                  type="number"
                                  class="input-field"
                                  [ngModelOptions]="{ standalone: true }"
                                  [ngModel]="
                                    getExistingPrice(
                                      part.enquiryPartId,
                                      basicDetails.enquiryDetails.make,
                                      1
                                    )
                                  "
                                  (ngModelChange)="
                                    onPriceChange(
                                      $event,
                                      basicDetails.enquiryDetails.make,
                                      part.enquiryPartId,
                                      1
                                    )
                                  "
                                  name="oe_{{ part.enquiryPartId }}"
                                />
                              </div>
                            </div>
                            <div
                              class="row"
                              *ngIf="
                                part?.oes &&
                                (basicDetails?.enquiryDetails?.partType ==
                                  '1' ||
                                  basicDetails?.enquiryDetails?.partType == '3')
                              "
                            >
                              <div class="col col-8">OES</div>
                              <div class="col col-4">
                                <input
                                  type="number"
                                  class="input-field"
                                  [ngModelOptions]="{ standalone: true }"
                                  [ngModel]="
                                    getExistingPrice(part.enquiryPartId, 'OES', 2)
                                  "
                                  (ngModelChange)="
                                    onPriceChange(
                                      $event,
                                      'OES',
                                      part.enquiryPartId,
                                      2
                                    )
                                  "
                                  name="oes_{{ part.enquiryPartId }}"
                                />
                              </div>
                            </div>
                          </div>
                        </div> -->

                        <div class="col col-6 right-align">
                          <div class="grid-sub">
                            <!-- Header -->
                            <div class="row header-row">
                              <div class="col col-4 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price (INC GST)
                              </div>
                              <div class="col col-4 header-col">Delivery Time</div>
                            </div>

                            <!-- OE Row -->
                            <div
                              class="row"
                              *ngIf="
                                part?.oe &&
                                (basicDetails?.enquiryDetails?.partType ==
                                  '1' ||
                                  basicDetails?.enquiryDetails?.partType == '2')
                              "
                            >
                              <div class="col col-4">
                                {{ basicDetails?.enquiryDetails?.make || "-" }}
                              </div>
                              <div class="col col-4">
                                <ng-container *ngIf="part?.entryMode == 2; else readOnlyEntryModePriceTop">
                                  <input
                                    type="number"
                                    class="input-field"
                                    [ngModelOptions]="{ standalone: true }"
                                    [ngModel]="
                                      getExistingPrice(
                                        part.enquiryPartId,
                                        basicDetails.enquiryDetails.make,
                                        1
                                      )
                                    "
                                    (ngModelChange)="
                                      onPriceChange(
                                        $event,
                                        basicDetails.enquiryDetails.make,
                                        part.enquiryPartId,
                                        1
                                      )
                                    "
                                    name="oe_{{ part.enquiryPartId }}"
                                  />
                                </ng-container>
                                <ng-template #readOnlyEntryModePriceTop>
                                  <span class="highlight small">
                                    {{
                                      (part?.priceDetails?.[0]?.sellingPrice ??
                                        part?.priceDetails?.[0]?.price) != null
                                        ? ((part?.priceDetails?.[0]?.sellingPrice ??
                                            part?.priceDetails?.[0]?.price
                                          | currency : "INR" : "symbol" : "1.0-1"))
                                        : "-"
                                    }}
                                  </span>
                                </ng-template>
                              </div>
                              <div class="col col-4 px-2">
                                <ng-container *ngIf="part?.entryMode == 2; else readOnlyEntryModeDeliveryTop">
                                  <select class="new-enquiry-select"
                                    [ngModelOptions]="{ standalone: true }"
                                    [ngModel]="getExistingDeliveryTime(part.enquiryPartId, basicDetails.enquiryDetails.make, 1) ?? part?.priceDetails?.[0]?.deliveryTime ?? ''"
                                    (ngModelChange)="getDeliveryTime($event, basicDetails?.enquiryDetails?.make, part?.enquiryPartId, 1)"
                                    name="deliveryTime_{{ part.enquiryPartId }}">
                                    <option value="" disabled>Delivery Time</option>
                                    <option value="1">Same Day</option>
                                    <option value="2">2 days</option>
                                    <option value="7">7 days</option>
                                  </select>
                                </ng-container>
                                <ng-template #readOnlyEntryModeDeliveryTop>
                                  <span class="highlight small">
                                    {{
                                      (part?.priceDetails?.[0]?.deliveryTime ?? part?.deliveryTime) != null
                                        ? getDeliveryTimeLabel(
                                            part?.priceDetails?.[0]?.deliveryTime ??
                                              part?.deliveryTime
                                          )
                                        : "-"
                                    }}
                                  </span>
                                </ng-template>
                              </div>
                            </div>

                          </div>
                        </div>

                        <!-- Verification Status -->
                        <div class="col-12 text-end mt-2 mb-1 pe-3" *ngIf="part?.verificationStatus">
                          <span class="badge" [ngClass]="{
                            'bg-warning text-dark': part.verificationStatus === 'pending',
                            'bg-success': part.verificationStatus === 'verified',
                            'bg-danger': part.verificationStatus === 'rejected'
                          }">
                            Verification: {{ part.verificationStatus | titlecase }}
                          </span>
                        </div>

                      </div>
                    </ng-container>
                  </div>
                  }
                </ng-container>
              </ng-container>

              <ng-template #manualEntryBlock>

                <!-- Sort Toggle Segment -->
              <!-- <div 
                class="sort-toggle d-flex justify-content-end pe-3" 
                *ngIf="enquiry?.statusDescription === 'Estimate received'"
              >
                <div class="btn-group" role="group" style="width: auto;">
                  <input 
                    type="radio" 
                    class="btn-check" 
                    name="reqType" 
                    id="bestPrice" 
                    value="1"
                    [(ngModel)]="reqType"
                    [ngModelOptions]="{standalone: true}"
                    (change)="confirmSortChange($event)"
                  >
                  <label class="btn btn-outline-primary" for="bestPrice">
                    <i class="fas fa-dollar-sign me-2"></i>
                    Best Price
                  </label>

                  <input 
                    type="radio" 
                    class="btn-check" 
                    name="reqType" 
                    id="fastDelivery" 
                    value="2"
                    [(ngModel)]="reqType"
                    [ngModelOptions]="{standalone: true}"
                    (change)="confirmSortChange($event)"
                  >
                  <label class="btn btn-outline-primary" for="fastDelivery">
                    <i class="fas fa-shipping-fast me-2"></i>
                    Fast Delivery
                  </label>
                </div>
              </div> -->

                <div class="grid-container">
                  <!-- Header Row -->
                  <div class="row header-row">
                    <div class="col col-3 header-col">Part No</div>
                    <div class="col col-4 header-col">Description</div>
                    <div class="col col-2 header-col">Qty</div>
                    <div class="col col-3 header-col">Image</div>
                  </div>

                  <!-- Parts Loop -->
                  <ng-container
                    *ngFor="
                      let part of basicDetails?.enquiryDetails?.partDetails;
                      let partIndex = index
                    "
                  >
                    <div
                      class="row part-row"
                      *ngIf="
                        ((enquiry?.statusDescription === 'Estimate received' ||
                          enquiry?.statusDescription === 'Estimate Sent' ||
                          enquiry?.statusDescription === 'Estimate Partially Received' || 
                          enquiry?.statusDescription === 'Estimate Partially Sent') &&
                          part?.priceDetails?.length > 0 &&
                          !part?.brand) ||
                        (enquiry?.statusDescription !== 'Estimate received' &&
                          enquiry?.statusDescription !== 'Estimate Sent' &&
                          enquiry?.statusDescription !== 'Estimate Partially Received' && 
                          enquiry?.statusDescription !== 'Estimate Partially Sent')
                      "
                    >
                      <!-- Part No -->
                      <div class="col col-3">
                        <span class="highlight medium">{{
                              part?.partNo || '-'
                            }}</span>
                        <!-- <ng-container *ngIf="part?.partNo; else editPartNo">
                          <span class="highlight medium">{{
                            part?.partNo
                          }}</span>
                        </ng-container>
                        <ng-template #editPartNo>
                          <input
                            type="text"
                            placeholder="Enter Part No"
                            (change)="onPartNoChange($event, part)"
                            class="custom-input"
                          />
                        </ng-template> -->
                      </div>

                      <!-- Description -->
                      <div class="col col-4">
                        <span class="highlight large">{{
                          part?.partDescription
                        }}</span>
                      </div>

                      <!-- Quantity -->
                      <div class="col col-2">
                        <span class="highlight small">{{ part?.qty }}</span>
                      </div>

                      <!-- Image Icon -->
                      <div class="col col-3">
                        <button
                          class="btn btn-link p-0"
                          [disabled]="!part?.url"
                          (click)="
                            part.url &&
                              showPartDetailsAttachment(partIndex, part)
                          "
                          [ngClass]="{
                            'text-primary': part.url,
                            'text-muted': !part.url
                          }"
                        >
                          <i class="fas fa-eye"></i>
                        </button>
                      </div>

                      <!-- Price Section: Estimate received/Sent -->
                      <ng-container
                        *ngIf="
                          enquiry?.statusDescription === 'Estimate received' ||
                          enquiry?.statusDescription === 'Estimate Sent' ||
                          enquiry?.statusDescription === 'Additional info required' ||
                          enquiry?.statusDescription === 'Estimate Partially Received' ||
                          enquiry?.statusDescription === 'Estimate Partially Sent'
                        "
                      >
                        <div
                          class="col col-6 right-align"
                          *ngIf="part?.priceDetails?.length > 0 && !part?.brand && part?.partNo"
                        >
                          <div class="grid-sub">
                            <div class="row header-row">
                              <!-- <div class="col col-5 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price(INC GST)
                              </div>
                              <div class="col col-3 header-col">Option</div> -->
                              <div class="col col-4 header-col">Brand</div>
                              <div class="col col-3 header-col">Billing Price(INC GST)</div>
                              <div class="col col-3 header-col">Delivery Time</div>
                              <div class="col col-2 header-col">Option</div>
                            </div>
                            <div
                              class="row"
                              *ngFor="let price of getSortedPriceDetails(part)"
                            >
                              <div class="col col-4">{{ price?.brand }}</div>
                              <!-- <div class="col col-4">{{ price?.price }}</div> -->

                              <div
                                class="col col-3"
                                *ngIf="
                                  accType == '1' &&
                                  (enquiry?.statusDescription ==
                                    'Estimate received' ||
                                    enquiry?.statusDescription ==
                                      'Additional info required' ||
                                    enquiry?.statusDescription ==
                                      'Estimate Partially Received')
                                "
                              >
                                <div class="price-stack">
                                  <div class="offer-line">
                                    <span class="offer-price">
                                      {{
                                        price?.sellingPrice ?? price?.price
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-1"
                                      }}
                                    </span>
                                    <span
                                      class="off-badge"
                                      *ngIf="
                                        price?.price &&
                                        price?.sellingPrice &&
                                        price?.price > price?.sellingPrice
                                      "
                                    >
                                      {{
                                        getDiscount(
                                          price?.price,
                                          price?.sellingPrice
                                        )
                                      }}% OFF
                                    </span>
                                  </div>
                                  <div
                                    class="mrp-line"
                                    *ngIf="price?.price && price?.sellingPrice && price?.price > price?.sellingPrice"
                                  >
                                    <span class="mrp"
                                      >MRP
                                      {{
                                        price?.price
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-0"
                                      }}</span
                                    >
                                    <span
                                      *ngIf="price?.price > price?.sellingPrice"
                                      class="save-amt"
                                      >You save
                                      {{
                                        getSave(
                                          price?.price,
                                          price?.sellingPrice
                                        )
                                          | currency
                                            : "INR"
                                            : "symbol"
                                            : "1.0-1"
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </div>

                              <div
                                class="col col-3"
                                *ngIf="
                                  accType == '2' &&
                                  (enquiry?.statusDescription == 'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent')
                                "
                              >
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{
                                          price?.landingPrice ?? price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      class="mrp-line"
                                      *ngIf="price?.price && price?.landingPrice && price?.price > price?.landingPrice"
                                    >
                                      <span class="mrp"
                                        >MRP
                                        {{
                                          price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}</span
                                      >
                                    </div>
                                  </div>
                              </div>

                               <!-- New Delivery Time Column -->
                              <div class="col col-3">
                                <span class="badge bg-info text-dark">
                                  <i class="fas fa-shipping-fast me-1"></i>
                                  {{ getDeliveryTimeLabel(price?.deliveryTime) }}
                                </span>
                              </div>
                              <div class="col col-2">
                                <ng-container
                                  *ngIf="
                                    enquiry?.statusDescription ==
                                    'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent'
                                  "
                                  >-</ng-container
                                >
                                <ng-container
                                  *ngIf="
                                    enquiry?.statusDescription ==
                                      'Estimate received' ||
                                    (enquiry?.statusDescription ==
                                      'Additional info required' &&
                                      accType === '1' ) ||
                                    (enquiry?.statusDescription ==
                                      'Estimate Partially Received' &&
                                    accType === '1' )
                                  "
                                >
                                  <input
                                    type="checkbox"
                                    [checked]="
                                      isSelected(
                                        part?.enquiryPartId,
                                        price.brand
                                      )
                                    "
                                    [disabled]="
                                      selectedGlobalSellerId !== null &&
                                      selectedGlobalSellerId !== price.sellerId
                                    "
                                    (change)="
                                      onCheckboxChange(
                                        part?.enquiryPartId,
                                        price,
                                        part.qty,
                                        $event
                                      )
                                    "
                                  />
                                </ng-container>
                              </div>

                            <!-- Branch Name-->
                              <div *ngIf="price?.branchName && accType == '2'" class="d-flex justify-content-end align-items-center mt-2">
                                <span class="badge bg-branch text-light px-4 py-2 shadow" style="font-size: 0.9rem; font-weight: 500; letter-spacing: 1px; border-radius: 1.5rem;">
                                  <i class="fas fa-map-marker-alt me-2"></i>
                                  Branch: {{ price.branchName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Selected Brand -->
                        <div class="col col-6 right-align" *ngIf="part?.brand">
                          <div class="grid-sub">
                            <div class="row header-row">
                              <!-- <div class="col col-5 header-col">Brand</div>
                              <div class="col col-4 header-col">
                                Billing Price(INC GST)
                              </div>
                              <div class="col col-3 header-col">Option</div> -->
                              <div class="col col-4 header-col">Brand</div>
                              <div class="col col-3 header-col">Billing Price(INC GST)</div>
                              <div class="col col-3 header-col">Delivery Time</div>
                              <div class="col col-2 header-col">Option</div>
                            </div>
                            <div class="row">
                              <div class="col col-4">{{ part?.brand }}</div>
                              <div class="col col-3" *ngIf="accType == '1' && (enquiry?.statusDescription == 'Estimate received'|| enquiry?.statusDescription == 'Additional info required' || enquiry?.statusDescription == 'Estimate Partially Received')">
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{ part?.sellingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                      </span>
                                      <span class="off-badge" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                                        {{ getDiscount(part?.price, part?.sellingPrice) }}% OFF
                                      </span>
                                    </div>
                                    <div class="mrp-line" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                                      <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>  
                                      <span *ngIf="part?.price > part?.sellingPrice"
                                        class="save-amt">You save {{ getSave(part?.price, part?.sellingPrice) | currency:'INR':'symbol':'1.0-1' }}</span>
                                    </div>
                                  </div>
                              </div>

                                <div class="col col-3" *ngIf="accType == '2' && (enquiry?.statusDescription == 'Estimate Sent' || enquiry?.statusDescription == 'Estimate Partially Sent')">
                                    <div class="price-stack">
                                      <div class="offer-line">
                                        <span class="offer-price">
                                          {{ part?.landingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                        </span>
                                      </div>
                                      <div class="mrp-line" *ngIf="part?.price && part?.landingPrice">
                                        <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>
                                      </div>
                                    </div>
                                </div>

                                <!-- New Delivery Time Column -->
                                <div class="col col-3">
                                  <span class="badge bg-info text-dark">
                                    <i class="fas fa-shipping-fast me-1"></i>
                                    {{ getDeliveryTimeLabel(part?.deliveryTime) }}
                                  </span>
                                </div>
                              <div class="col col-3">-</div>

                              <!-- Branch Name -->
                              <div *ngIf="part?.branchName && accType == '2'" class="d-flex justify-content-end align-items-center mt-2">
                                <span class="badge bg-branch text-light px-4 py-2 shadow" style="font-size: 0.9rem; font-weight: 500; letter-spacing: 1px; border-radius: 1.5rem;">
                                  <i class="fas fa-map-marker-alt me-2"></i>
                                  Branch: {{ part.branchName }}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <ng-container *ngIf="accType == '1' && !part?.partNo">
                        <div class="stock-not-available-msg text-end py-1 pe-3">
                          <span class="badge bg-warning text-dark">
                            <i class="fas fa-exclamation-circle me-1"></i>
                            Stock not available
                          </span>
                        </div>
                      </ng-container>
                      
                      </ng-container>

                      

                      <!-- New Enquiry / Additional Info - accType 2 -->
                      <ng-container
                        *ngIf="
                          (enquiry?.statusDescription == 'New Enquiry' ||
                            enquiry?.statusDescription ==
                              'Additional info required') &&
                          accType == '2'
                        "
                      >
                        <ng-container
                          *ngIf="enquiry?.statusDescription === 'New Enquiry'"
                        >
                          <div class="col col-6 right-align">
                            <div class="grid-sub">
                              <!-- Header -->
                              <div class="row header-row">
                                <div class="col col-4 header-col">Brand</div>
                                <div class="col col-4 header-col">
                                  Billing Price (INC GST)
                                </div>
                                <div class="col col-4 header-col">Delivery Time</div>
                              </div>

                              <!-- OE Row -->
                              <div
                                class="row"
                                *ngIf="
                                  part?.oe &&
                                  (basicDetails?.enquiryDetails?.partType ==
                                    '1' ||
                                    basicDetails?.enquiryDetails?.partType ==
                                      '2')
                                "
                              >
                                <div class="col col-4">
                                  {{
                                    basicDetails?.enquiryDetails?.make || "-"
                                  }}
                                </div>
                                <div class="col col-4">
                                  <ng-container *ngIf="part?.entryMode == 2; else readOnlyEntryModePrice">
                                    <input
                                      type="number"
                                      class="input-field"
                                      placeholder="MRP"
                                      (input)="
                                        getPrice(
                                          $event,
                                          basicDetails?.enquiryDetails?.make,
                                          part?.enquiryPartId,
                                          1
                                        )
                                      "
                                    />
                                  </ng-container>
                                  <ng-template #readOnlyEntryModePrice>
                                    <span class="highlight small">
                                      {{
                                        (part?.priceDetails?.[0]?.sellingPrice ??
                                          part?.priceDetails?.[0]?.price) != null
                                          ? ((part?.priceDetails?.[0]?.sellingPrice ??
                                              part?.priceDetails?.[0]?.price
                                            | currency : "INR" : "symbol" : "1.0-1"))
                                          : "-"
                                      }}
                                    </span>
                                  </ng-template>
                                </div>
                                <div class="col col-4 px-2">
                                  <ng-container *ngIf="part?.entryMode == 2; else readOnlyEntryModeDelivery">
                                    <select class="new-enquiry-select"
                                      [ngModelOptions]="{ standalone: true }"
                                      [ngModel]="getExistingDeliveryTime(part.enquiryPartId, basicDetails.enquiryDetails.make, 1) ?? part?.priceDetails?.[0]?.deliveryTime ?? ''"
                                      (ngModelChange)="getDeliveryTime($event, basicDetails?.enquiryDetails?.make, part?.enquiryPartId, 1)"
                                      name="deliveryTime_{{ part.enquiryPartId }}">
                                      <option value="" disabled>Delivery Time</option>
                                      <option value="1">Same Day</option>
                                      <option value="2">2 days</option>
                                      <option value="7">7 days</option>
                                    </select>
                                  </ng-container>
                                  <ng-template #readOnlyEntryModeDelivery>
                                    <span class="highlight small">
                                      {{
                                        (part?.priceDetails?.[0]?.deliveryTime ?? part?.deliveryTime) != null
                                          ? getDeliveryTimeLabel(
                                              part?.priceDetails?.[0]?.deliveryTime ??
                                                part?.deliveryTime
                                            )
                                          : "-"
                                      }}
                                    </span>
                                  </ng-template>
                                </div>
                              </div>

                            </div>
                          </div>
                        </ng-container>

                        <!-- Quotation Raise Cases -->
                        <ng-container
                          *ngIf="
                            basicDetails?.enquiryDetails?.checkQuotationRaise &&
                            part?.priceDetails?.length > 0 &&
                            part?.brand == '' &&
                            enquiry?.statusDescription ==
                              'Additional info required'
                          "
                        >
                          <div
                            class="col col-6 right-align"
                            *ngIf="
                              part?.priceDetails?.length > 0 &&
                              (!part?.brand || part?.brand == '')
                            "
                          >
                            <div class="grid-sub">
                              <div class="row header-row">
                                <div class="col col-8 header-col">Brand</div>
                                <div class="col col-4 header-col">
                                  Billing Price(INC GST)
                                </div>
                              </div>
                              <div
                                class="row"
                                *ngFor="
                                  let price of getSortedPriceDetails(part)
                                "
                              >
                                <div class="col col-8">{{ price?.brand }}</div>

                                <div
                                  class="col col-4"
                                  *ngIf="
                                    accType == '2'; else accType1Price"
                                >
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{
                                          price?.landingPrice ?? price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}
                                      </span>
                                    </div>
                                    <div
                                      class="mrp-line"
                                      *ngIf="
                                        price?.price && price?.landingPrice
                                      "
                                    >
                                      <span class="mrp"
                                        >MRP
                                        {{
                                          price?.price
                                            | currency
                                              : "INR"
                                              : "symbol"
                                              : "1.0-1"
                                        }}</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <ng-template #accType1Price>
                                    <div class="col col-4">
                                      <div class="price-stack">
                                        <div class="offer-line">
                                          <span class="offer-price">
                                            {{
                                              price?.sellingPrice ?? price?.price
                                                | currency
                                                  : "INR"
                                                  : "symbol"
                                                  : "1.0-1"
                                            }}
                                          </span>
                                          <span
                                            class="off-badge"
                                            *ngIf="
                                              price?.price &&
                                              price?.sellingPrice &&
                                              price?.price > price?.sellingPrice
                                            "
                                          >
                                            {{
                                              getDiscount(
                                                price?.price,
                                                price?.sellingPrice
                                              )
                                            }}% OFF
                                          </span>
                                        </div>
                                        <div
                                          class="mrp-line"
                                          *ngIf="
                                            price?.price && price?.sellingPrice
                                          "
                                        >
                                          <span class="mrp"
                                            >MRP
                                            {{
                                              price?.price
                                                | currency
                                                  : "INR"
                                                  : "symbol"
                                                  : "1.0-0"
                                            }}</span
                                          >
                                          <span
                                            *ngIf="
                                              price?.price > price?.sellingPrice
                                            "
                                            class="save-amt"
                                            >You save
                                            {{
                                              getSave(
                                                price?.price,
                                                price?.sellingPrice
                                              )
                                                | currency
                                                  : "INR"
                                                  : "symbol"
                                                  : "1.0-1"
                                            }}</span
                                          >
                                        </div>
                                      </div>
                                    </div>
                                </ng-template>

                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            (this.basicDetails?.enquiryDetails
                              ?.checkQuotationRaise &&
                              part?.priceDetails?.length > 0) ||
                            (part?.brand &&
                              enquiry?.statusDescription ==
                                'Additional info required')
                          "
                        >
                          <div
                            class="col col-6 right-align"
                            *ngIf="part?.brand"
                          >
                            <div class="grid-sub">
                              <div class="row header-row">
                                <div class="col col-8 header-col">Brand</div>
                                <div class="col col-4 header-col">
                                  Billing Price(INC GST)
                                </div>
                              </div>
                              <div class="row">
                                <div class="col col-8">{{ part?.brand }}</div>


                                <div class="col col-4" *ngIf="accType == '2'; else accType1Price">
                                  <div class="price-stack">
                                    <div class="offer-line">
                                      <span class="offer-price">
                                        {{ part?.landingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                      </span>
                                    </div>
                                    <div class="mrp-line" *ngIf="part?.price && part?.landingPrice">
                                      <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>
                                    </div>
                                  </div>
                                </div>
                                <ng-template #accType1Price>
                                  <div class="col col-4" >
                                    <div class="price-stack">
                                      <div class="offer-line">
                                        <span class="offer-price">
                                          {{ part?.sellingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                                        </span>
                                        <span class="off-badge" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                                          {{ getDiscount(part?.price, part?.sellingPrice) }}% OFF
                                        </span>
                                      </div>
                                      <div class="mrp-line" *ngIf="part?.price && part?.sellingPrice">
                                        <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>  
                                        <span *ngIf="part?.price > part?.sellingPrice"
                                          class="save-amt">You save {{ getSave(part?.price, part?.sellingPrice) | currency:'INR':'symbol':'1.0-1' }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container
                          *ngIf="
                            (this.basicDetails?.enquiryDetails
                              ?.checkQuotationRaise &&
                              part?.priceDetails?.length == 0) ||
                            (part?.priceDetails == null &&
                              enquiry?.statusDescription ==
                                'Additional info required')
                          "
                        >
                          <div class="col col-6 right-align">
                            <div class="grid-sub">
                              <!-- Header -->
                              <div class="row header-row">
                                <div class="col col-8 header-col">Brand</div>
                                <div class="col col-4 header-col">
                                  Billing Price (INC GST)
                                </div>
                              </div>

                              <!-- OE Row -->
                              <div
                                class="row"
                                *ngIf="
                                  part?.oe &&
                                  (basicDetails?.enquiryDetails?.partType ==
                                    '1' ||
                                    basicDetails?.enquiryDetails?.partType ==
                                      '2')
                                "
                              >
                                <div class="col col-8">
                                  {{
                                    basicDetails?.enquiryDetails?.make || "-"
                                  }}
                                </div>
                                <div class="col col-4">
                                  <input
                                    type="number"
                                    class="input-field"
                                    placeholder="MRP"
                                    (input)="
                                      getPrice(
                                        $event,
                                        basicDetails?.enquiryDetails?.make,
                                        part?.enquiryPartId,
                                        1
                                      )
                                    "
                                  />
                                </div>
                              </div>

                              <!-- OES Row with Select -->
                              <div
                                class="row"
                                *ngIf="
                                  part?.oes &&
                                  (basicDetails?.enquiryDetails?.partType ==
                                    '1' ||
                                    basicDetails?.enquiryDetails?.partType ==
                                      '3')
                                "
                              >
                                <div class="col col-8 px-2">
                                  <select
                                    class="input-field"
                                    [(ngModel)]="part.oesBrand"
                                    [ngModelOptions]="{ standalone: true }"
                                    (change)="onOesBrandChange(part)"
                                  >
                                    <option
                                      *ngFor="let brand of oesBrandList"
                                      [ngValue]="brand"
                                    >
                                      {{ brand.title }}
                                    </option>
                                  </select>
                                </div>
                                <div class="col col-4">
                                  <input
                                    type="number"
                                    class="input-field"
                                    placeholder="MRP"
                                    [disabled]="!part.oesBrand"
                                    (input)="
                                      getPrice(
                                        $event,
                                        part.oesBrand.title,
                                        part?.enquiryPartId,
                                        2
                                      )
                                    "
                                  />
                                </div>
                              </div>

                              <!-- Imported Row -->
                              <div
                                class="row"
                                *ngIf="
                                  part?.oes &&
                                  (basicDetails?.enquiryDetails?.partType ==
                                    '1' ||
                                    basicDetails?.enquiryDetails?.partType ==
                                      '3')
                                "
                              >
                                <div class="col col-8 px-2">
                                  <input
                                    type="text"
                                    class="input-field"
                                    placeholder="Imported"
                                    [(ngModel)]="part.importedBrand"
                                    [ngModelOptions]="{ standalone: true }"
                                  />
                                </div>
                                <div class="col col-4">
                                  <input
                                    type="number"
                                    class="input-field"
                                    placeholder="Landing Price"
                                    (input)="
                                      getPrice(
                                        $event,
                                        part.importedBrand
                                          ? part.importedBrand
                                          : 'Imported',
                                        part?.enquiryPartId,
                                        3
                                      )
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>

                      <!-- Verification Status -->
                      <div class="col-12 text-end mt-2 mb-1 pe-3" *ngIf="part?.verificationStatus">
                        <span class="badge" [ngClass]="{
                          'bg-warning text-dark': part.verificationStatus === 'pending',
                          'bg-success': part.verificationStatus === 'verified',
                          'bg-danger': part.verificationStatus === 'rejected'
                        }">
                          Verification: {{ part.verificationStatus | titlecase }}
                        </span>
                      </div>

                    </div>
                  </ng-container>
                </div>
              </ng-template>
            </div>

            <!-- parts Details Section -->
            <div
              class="section partDetails"
              *ngIf="
                enquiry?.statusDescription === 'Order Placed' ||
                enquiry?.statusDescription === 'Pending for invoice' ||
                enquiry?.statusDescription === 'Billed/intrasit' ||
                enquiry?.statusDescription === 'Billed/Delivered' ||
                enquiry?.statusDescription === 'Return Raised' ||
                enquiry?.statusDescription === 'Pending For Return Approval' ||
                enquiry?.statusDescription === 'Return Approved' ||
                enquiry?.statusDescription === 'Pickup in progress' ||
                enquiry?.statusDescription === 'Pending For POD Approval' ||
                enquiry?.statusDescription === 'Dispatch Confirmation Pending'
              "
            >
               <div class="section-header d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-2">
                  <i class="fas fa-cogs"></i>
                  <h2>Part Details</h2>
                </div>
                <ng-container *ngIf="basicDetails?.enquiryDetails?.orderPlacedExcel?.url &&
                  enquiry?.statusDescription === 'Order Placed' && accType === '2'">
                  <a class="btn btn-success px-4 py-2 d-flex align-items-center gap-2"
                     [href]="basicDetails?.enquiryDetails?.orderPlacedExcel?.url"
                     target="_blank"
                     download
                     style="font-weight: 500; font-size: 1rem;">
                    <i class="fas fa-download" style="color: #fff;font-size: 1rem;"></i>
                    Download Excel
                  </a>
                </ng-container>
              </div>

              <div class="table-responsive">
                <div class="row font-weight-bold border-bottom py-2 bg-light">
                  <div class="col-3">Part No</div>
                  <div class="col-4">Description</div>
                  <div class="col-3">Qty</div>
                  <div class="col-2">Opt</div>
                </div>

                <ng-container
                  *ngFor="
                    let part of basicDetails?.enquiryDetails?.partDetails;
                    let i = index
                  "
                >
                  <div
                    class="row py-2 align-items-center border-bottom"
                    *ngIf="part?.brand"
                  >
                    <div class="col-3">
                      <span class="highlight medium">{{ part?.partNo }}</span>
                    </div>
                    <div class="col-4">
                      <span class="highlight large">{{
                        part?.partDescription
                      }}</span>
                    </div>
                    <div class="col-3">
                      <span class="highlight small">{{ part?.qty }}</span>
                    </div>
                    <!-- <div class="col-2">
                      <i
                        class="fas fa-eye"
                        [style.color]="part.url ? 'blue' : 'gray'"
                        [style.cursor]="part.url ? 'pointer' : 'not-allowed'"
                        (click)="
                          part.url ? showPartDetailsAttachment(i, part) : null
                        "
                      ></i>
                    </div> -->

                            <!-- Options (View/Edit) -->
                    <div class="col-2">
                      <div class="actions-group">
                        <!-- View Icon -->
                        <i
                          class="fas fa-eye action-icon view-icon"
                          [style.cursor]="part.url ? 'pointer' : 'not-allowed'"
                          (click)="part.url ? showPartDetailsAttachment(i, part) : null"
                          title="View attachment"
                        ></i>

                        <!-- Edit Icon for Seller when Order Placed -->
                        <i
                          class="fas fa-edit action-icon edit-icon"
                          *ngIf="enquiry?.statusDescription === 'Order Placed' && accType === '2'"
                          (click)="openEditPartModal(i, part)"
                          title="Edit part details"
                        ></i>
                      </div>
                    </div>

                    <!-- Extra Info -->
                    <div class="col-3 text-muted">Brand</div>
                    <div class="col-3 text-muted">Billing Price (INC GST)</div>
                    <div class="col-3 text-muted">Delivery Time</div>
                    <div class="col-3"></div>

                    <div class="col-3">
                      <span class="highlight large">{{ part?.brand }}</span>
                    </div>
                    <div class="col col-3" *ngIf="accType == '1'">
                      <div class="price-stack">
                        <div class="offer-line">
                          <span class="offer-price">
                            {{ part?.sellingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                          </span>
                          <span class="off-badge" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                            {{ getDiscount(part?.price, part?.sellingPrice) }}% OFF
                          </span>
                        </div>
                        <div class="mrp-line" *ngIf="part?.price && part?.sellingPrice && part?.price > part?.sellingPrice">
                          <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>  
                          <span *ngIf="part?.price > part?.sellingPrice"
                            class="save-amt">You save {{ getSave(part?.price, part?.sellingPrice) | currency:'INR':'symbol':'1.0-1' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col col-3" *ngIf="accType == '2'">
                      <div class="price-stack">
                        <div class="offer-line">
                          <span class="offer-price">
                            {{ part?.landingPrice ?? part?.price | currency:'INR':'symbol':'1.0-1' }}
                          </span>
                        </div>
                        <!-- <div class="mrp-line" *ngIf="part?.price && part?.landingPrice && part?.price > part?.landingPrice">
                          <span class="mrp">MRP {{ part?.price | currency:'INR':'symbol':'1.0-1' }}</span>
                        </div> -->
                      </div>
                    </div>
                    <!-- Delivery Time Badge -->
                    <div class="col-3">
                      <span class="badge bg-info text-white delivery-badge">
                        <i class="fas fa-shipping-fast me-1"></i>
                        {{ getDeliveryTimeLabel(part?.deliveryTime) }}
                      </span>
                    </div>
                    
                    <div class="col-3"></div>

                     <!-- Branch Name-->
                    <div *ngIf="part?.branchName && accType == '2'" class="d-flex justify-content-end align-items-center mt-2">
                      <span class="badge bg-branch text-light px-4 py-2 shadow" style="font-size: 0.9rem; font-weight: 500; letter-spacing: 1px; border-radius: 1.5rem;">
                        <i class="fas fa-map-marker-alt me-2"></i>
                        Branch: {{ part.branchName }}
                      </span>
                    </div>

                    <!-- Verification Status -->
                    <div class="col-12 text-end mt-2 mb-1 pe-3" *ngIf="part?.verificationStatus">
                      <span class="badge" [ngClass]="{
                        'bg-warning text-dark': part.verificationStatus === 'pending',
                        'bg-success': part.verificationStatus === 'verified',
                        'bg-danger': part.verificationStatus === 'rejected'
                      }">
                        Verification: {{ part.verificationStatus | titlecase }}
                      </span>
                    </div>

                  </div>
                </ng-container>
              </div>

              <!-- Submit Button for Additional Info -->
              <ng-container
                *ngIf="
                  enquiry?.statusDescription === 'Additional info required'
                "
              >
                <div class="footActions mt-3">
                  <button
                    type="button"
                    class="btn btn-primary w-100"
                    (click)="AddInfoReqSubmit()"
                    [disabled]="isLoading"
                  >
                    <span
                      *ngIf="isLoading"
                      class="spinner-border spinner-border-sm mr-2"
                      role="status"
                    ></span>
                    Submit
                  </button>
                </div>
              </ng-container>
            </div>

            <!-- order Details Section -->
            <div
              class="section orderDetails"
              *ngIf="
                enquiry?.statusDescription === 'Additional info required' &&
                enquiry?.statusDescription !== 'Estimate received' &&
                basicDetails?.enquiryDetails?.noPriceStatus &&
                Object.keys(selectedPrices).length > 0
              "
            >
              <div class="section-header">
                <i class="fas fa-receipt"></i>
                <h2>Order Details</h2>
              </div>

              <div class="container-fluid">
                <!-- <div class="row py-2">
                  <div class="col-6">Delivery Time</div>
                  <div class="col-6 font-weight-bold">
                    <ng-container
                      *ngIf="
                        isDeliveryTimeMultiple(
                          basicDetails?.enquiryDetails?.deliveryTime
                        );
                        else singleDelivery
                      "
                    >
                      <ng-container *ngIf="deliveryTime; else noSelect">
                        {{ ": " + deliveryTime }}
                      </ng-container>
                      <ng-template #noSelect>
                        <span>: -</span>
                      </ng-template>
                    </ng-container>
                    <ng-template #singleDelivery>
                      <ng-container
                        *ngIf="
                          basicDetails?.enquiryDetails?.deliveryTime;
                          else noDelivery
                        "
                      >
                        {{ ": " + basicDetails?.enquiryDetails?.deliveryTime }}
                      </ng-container>
                      <ng-template #noDelivery>
                        <span>: -</span>
                      </ng-template>
                    </ng-template>
                  </div>
                </div> -->

                <div class="row py-2" *ngIf="accType === '1'">
                  <div class="col-6">Total Amount</div>

                  <div class="col-6">
                    <div class="total-amount-display">
                      <div class="main-amount">
                        <span class="colon">:</span>
                        <span class="offer-price">
                          {{ totalAmount | currency:'INR':'symbol':'1.0-0' }}
                        </span>
                      </div>
                      
                      <!-- Show savings if totalSaveForBuyer exists and is greater than 0 -->
                      <div class="savings-info" *ngIf=" totalSavings > 0">
                        <span class="savings-badge">
                          <ion-icon name="gift-outline"></ion-icon>
                          You saved {{ totalSavings | currency:'INR':'symbol':'1.0-0' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row py-2" *ngIf="accType == '1'">
                  <div class="col-9">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Po No"
                      formControlName="poNo"
                    />
                  </div>
                  <div class="col-3">
                    <button
                      class="btn btn-primary btn-sm w-100"
                      (click)="poUpload()"
                      [disabled]="!registerForm.get('poNo')?.value"
                    >
                      Upload
                    </button>
                  </div>
                </div>

                <div
                  class="row py-2"
                  *ngIf="
                    basicDetails?.enquiryDetails?.PoDoc &&
                    basicDetails?.enquiryDetails?.PoDocId
                  "
                >
                  <div class="col-9">PO Doc</div>
                  <div class="col-3 d-flex justify-content-end gap-2">
                    <i
                      class="fas fa-download text-primary"
                      role="button"
                      (click)="
                        viewPdf(
                          basicDetails?.enquiryDetails?.PoDoc,
                          basicDetails?.enquiryDetails?.poNo
                        )
                      "
                    ></i>
                    <i
                      class="fas fa-trash text-danger"
                      role="button"
                      (click)="
                        deleteAttachment(
                          basicDetails?.enquiryDetails?.PoDocId,
                          1
                        )
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- Query Details Section -->
            <div
              class="section queryDetails"
              *ngIf="
                enquiry?.statusDescription === 'Additional info required' &&
                basicDetails?.enquiryDetails?.queries?.length > 0 &&
                accType == '1'
              "
            >
              <div class="section-header">
                <i class="fas fa-receipt"></i>
                <h2>Query Detail</h2>
              </div>

              <!-- If no queryStatus -->
              <ng-container *ngIf="!basicDetails?.enquiryDetails?.queryStatus">
                <div class="container-fluid">
                  <div class="row font-weight-bold border-bottom py-2">
                    <div class="col-6">Queries</div>
                    <div class="col-6">Remarks</div>
                  </div>

                  <div
                    class="row py-2"
                    *ngFor="
                      let query of basicDetails?.enquiryDetails?.queries;
                      let queryIndex = index
                    "
                  >
                    <div class="col-6">{{ query?.type }}</div>
                    <div class="col-6">{{ query?.remark }}</div>
                    <div class="col-12 mt-2">
                      <input
                        type="text"
                        class="form-control"
                        [value]="query?.reply"
                        placeholder="Enter Your Remarks"
                        (input)="logReply($event, query?.type)"
                      />
                    </div>
                    <div class="col-12"><hr /></div>
                  </div>
                </div>
              </ng-container>

              <!-- If queryStatus is present -->
              <ng-container *ngIf="basicDetails?.enquiryDetails?.queryStatus">
                <div class="container-fluid">
                  <div class="row font-weight-bold border-bottom py-2">
                    <div class="col-4">Queries</div>
                    <div class="col-4">Remarks</div>
                    <div class="col-4">Reply</div>
                  </div>

                  <div
                    class="row py-2"
                    *ngFor="
                      let query of basicDetails?.enquiryDetails?.queries;
                      let queryIndex = index
                    "
                  >
                    <div class="col-4">{{ query?.type }}</div>
                    <div class="col-4">{{ query?.remark }}</div>
                    <div class="col-4">{{ query?.reply || "-" }}</div>
                    <div class="col-12"><hr /></div>
                  </div>
                </div>
              </ng-container>

              <!-- Submit Button -->
              <ng-container
                *ngIf="
                  enquiry?.statusDescription === 'Additional info required'
                "
              >
                <div class="text-end mt-3">
                  <button
                    class="btn btn-success w-100"
                    type="button"
                    (click)="AddInfoReqSubmit()"
                  >
                    Submit
                  </button>
                </div>
              </ng-container>
            </div>

            <!-- Query Details Section (accType == '2') -->
            <div
              class="section queryDetails"
              *ngIf="
                enquiry?.statusDescription === 'Additional info required' &&
                basicDetails?.enquiryDetails?.queries?.length > 0 &&
                accType == '2'
              "
            >
              <div class="section-header">
                <i class="fas fa-receipt"></i>
                <h2>Query Detail</h2>
              </div>

              <div class="container-fluid">
                <div class="row font-weight-bold border-bottom py-2">
                  <div class="col-4">Queries</div>
                  <div class="col-4">Comment</div>
                  <div class="col-4">Reply</div>
                </div>

                <div
                  class="row py-2"
                  *ngFor="
                    let query of basicDetails?.enquiryDetails?.queries;
                    let queryIndex = index
                  "
                >
                  <div class="col-4">{{ query?.type }}</div>
                  <div class="col-4">{{ query?.remark }}</div>
                  <div class="col-4">
                    {{ query?.reply ? query?.reply : "-" }}
                  </div>
                </div>
              </div>
            </div>

            <!-- order Details Section -->
            <!-- <div
              class="section orderDetails"
              *ngIf="
                enquiry?.statusDescription === 'New Enquiry' ||
                (enquiry?.statusDescription === 'Additional info required' &&
                  accType == '2')
              "
            >
              <div class="section-header">
                <i class="fas fa-list"></i>
                <h2>Other Details</h2>
              </div>

              <div class="form-group">
                <label for="deliveryTime">Delivery Time</label>
                <select
                  id="deliveryTime"
                  class="form-control"
                  formControlName="deliveryTime"
                >
                  <option value="" disabled selected>
                    Select Delivery Time
                  </option>
                  <option value="1">Same Day</option>
                  <option value="2">1–2 days</option>
                  <option value="3">3–5 days</option>
                  <option value="4">7–15 days</option>
                </select>
              </div>
            </div> -->

            <!-- other Details Section -->
            <div
              class="section orderDetails modern-card"
              *ngIf="
                enquiry?.statusDescription == 'Order Placed' ||
                enquiry?.statusDescription == 'Pending for invoice' ||
                enquiry?.statusDescription == 'Billed/intrasit' ||
                enquiry?.statusDescription == 'Billed/Delivered' ||
                enquiry?.statusDescription == 'Return Raised' ||
                enquiry?.statusDescription == 'Pending For Return Approval' ||
                enquiry?.statusDescription == 'Return Approved' ||
                enquiry?.statusDescription == 'Pickup in progress' ||
                enquiry?.statusDescription == 'Pending For POD Approval' ||
                enquiry?.statusDescription == 'Dispatch Confirmation Pending'
              "
            >
              <div class="section-header">
                <i class="fas fa-file-invoice-dollar"></i>
                <h2>Other Details</h2>
              </div>

              <!-- Total Amount Card -->
              <div class="detail-card mb-3">
                <div class="detail-row">
                  <div class="detail-label">
                    <i class="fas fa-wallet me-2 text-success"></i>
                    <span>Total Amount</span>
                  </div>
                  <div class="detail-value">
                    <div class="amount-wrapper">
                      <ng-container *ngIf="getEditedPartsCount() == 0; else editedAmount">
                        <span class="main-price">
                          {{ basicDetails?.enquiryDetails?.totalAmount | currency:'INR':'symbol':'1.0-0' }}
                        </span>
                        <div class="savings-badge" *ngIf="basicDetails?.enquiryDetails?.totalSaveForBuyer && basicDetails?.enquiryDetails?.totalSaveForBuyer > 0">
                          <i class="fas fa-gift"></i>
                          You saved {{ basicDetails?.enquiryDetails?.totalSaveForBuyer | currency:'INR':'symbol':'1.0-0' }}
                        </div>
                      </ng-container>
                      <ng-template #editedAmount>
                        <span class="main-price">
                          {{ getCalculatedTotalAmount() | currency:'INR':'symbol':'1.0-0' }}
                        </span>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <!-- PO Number Card -->
              <div class="detail-card mb-3" *ngIf="basicDetails?.enquiryDetails?.poNo && accType == '1'">
                <div class="detail-row">
                  <div class="detail-label">
                    <i class="fas fa-hashtag me-2 text-primary"></i>
                    <span>PO Number</span>
                  </div>
                  <div class="detail-value">
                    <span class="badge bg-light text-dark">{{ basicDetails.enquiryDetails?.poNo || "-" }}</span>
                  </div>
                </div>
              </div>

              <!-- Documents Section -->
              <ng-container class="documents-grid">
                <!-- PO Doc -->
                <div
                  class="doc-card"
                  *ngIf="
                    basicDetails?.enquiryDetails?.PoDoc &&
                    basicDetails?.enquiryDetails?.PoDocId &&
                    accType == '1'
                  "
                >
                  <div class="doc-icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                  <div class="doc-info">
                    <h6>PO Document</h6>
                    <small>{{ basicDetails?.enquiryDetails?.poNo }}</small>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary rounded-pill"
                    (click)="
                      viewPdf(
                        basicDetails?.enquiryDetails?.PoDoc,
                        basicDetails?.enquiryDetails?.poNo
                      )
                    "
                  >
                    <i class="fas fa-download me-1"></i>
                    Download
                  </button>
                </div>

                <!-- Invoice Doc -->
                <div
                  class="doc-card"
                  *ngIf="
                    basicDetails?.enquiryDetails?.invoiceAttachment &&
                    accType == '1'
                  "
                >
                  <div class="doc-icon invoice">
                    <i class="fas fa-file-invoice"></i>
                  </div>
                  <div class="doc-info">
                    <h6>Invoice Document</h6>
                    <small>Official invoice</small>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-success rounded-pill"
                    (click)="
                      viewPdf(
                        basicDetails?.enquiryDetails?.invoiceAttachment,
                        'invoice'
                      )
                    "
                  >
                    <i class="fas fa-download me-1"></i>
                    Download
                  </button>
                </div>

                <!-- POD Doc -->
                <div
                  class="doc-card"
                  *ngIf="
                    basicDetails?.enquiryDetails?.podId &&
                    basicDetails?.enquiryDetails?.podDoc &&
                    accType == '1'
                  "
                >
                  <div class="doc-icon pod">
                    <i class="fas fa-clipboard-check"></i>
                  </div>
                  <div class="doc-info">
                    <h6>POD Document</h6>
                    <small>Proof of delivery</small>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-info rounded-pill"
                    (click)="viewPdf(basicDetails?.enquiryDetails?.podDoc, 'pod')"
                  >
                    <i class="fas fa-download me-1"></i>
                    Download
                  </button>
                </div>
              </ng-container>

              <!-- Seller Upload Section -->
              <div
                class="upload-section-card"
                *ngIf="
                  accType == '2' &&
                  enquiry?.statusDescription != 'Billed/intrasit' &&
                  enquiry?.statusDescription != 'Billed/Delivered' &&
                  enquiry?.statusDescription != 'Return Raised' &&
                  enquiry?.statusDescription != 'Pending For Return Approval' &&
                  enquiry?.statusDescription != 'Return Approved' &&
                  enquiry?.statusDescription != 'Pickup in progress' &&
                  enquiry?.statusDescription != 'Pending For POD Approval' &&
                  enquiry?.statusDescription != 'Dispatch Confirmation Pending' &&
                  getEditedPartsCount() == 0
                "
              >
                <h6 class="upload-title">
                  <i class="fas fa-cloud-upload-alt me-2"></i>
                  Upload Document
                </h6>
                <div class="upload-controls">
                  <select
                    class="form-select modern-select"
                    (change)="onUploadDocTypeChange($event)"
                  >
                    <option [value]="null" disabled selected>
                      Select Document Type
                    </option>
                    <option
                      *ngFor="let item of orderDocQueryList"
                      [value]="item?.id"
                    >
                      {{ item?.value }}
                    </option>
                  </select>
                  <button
                    class="btn btn-primary upload-btn"
                    (click)="newDocAttachment()"
                  >
                    <i class="fas fa-upload me-2"></i>
                    Upload
                  </button>
                </div>
              </div>

              <!-- Seller Docs List -->
              <div
                class="uploaded-docs-section"
                *ngIf="
                  basicDetails?.enquiryDetails?.sellerDoc?.length > 0 &&
                  ((accType == '2' && getEditedPartsCount() == 0) ||
                  ((enquiry?.statusDescription == 'Billed/intrasit' || enquiry?.statusDescription == 'Billed/Delivered') && accType == '1'))
                "
              >
                <h6 class="section-subtitle">
                  <i class="fas fa-folder-open me-2"></i>
                  Uploaded Documents
                </h6>
                <div class="docs-list">
                  <div
                    class="doc-item"
                    *ngFor="
                      let attachment of basicDetails?.enquiryDetails?.sellerDoc
                    "
                  >
                    <div class="doc-item-icon">
                      <i class="fas fa-file-alt"></i>
                    </div>
                    <div class="doc-item-info">
                      <span class="doc-type">{{ getDocAttachmentValue(attachment.docType) }}</span>
                    </div>
                    <div class="doc-item-actions">
                      <button
                        class="btn btn-sm btn-outline-primary me-2"
                        (click)="viewPdf(attachment?.docUrl, 'document')"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                      <button
                        *ngIf="
                          accType == '2' &&
                          enquiry?.statusDescription != 'Billed/intrasit' &&
                          enquiry?.statusDescription != 'Billed/Delivered' &&
                          enquiry?.statusDescription != 'Return Raised' &&
                          enquiry?.statusDescription != 'Pending For Return Approval' &&
                          enquiry?.statusDescription != 'Return Approved' &&
                          enquiry?.statusDescription != 'Pickup in progress' &&
                          enquiry?.statusDescription != 'Pending For POD Approval' &&
                          enquiry?.statusDescription != 'Dispatch Confirmation Pending'
                        "
                        class="btn btn-sm btn-outline-danger"
                        (click)="deleteAttachment(attachment?.docId, 2)"
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Payment Receipt -->
              <!-- <div
                class="doc-card payment-receipt"
                *ngIf="
                  basicDetails?.enquiryDetails?.paymentReceipt && accType == '2'
                "
              >
                <div class="doc-icon payment">
                  <i class="fas fa-receipt"></i>
                </div>
                <div class="doc-info">
                  <h6>Payment Receipt</h6>
                  <small>Transaction proof</small>
                </div>
                <button
                  type="button"
                  class="btn btn-sm btn-warning rounded-pill"
                  (click)="
                    viewPdf(
                      basicDetails?.enquiryDetails?.paymentReceipt,
                      'paymentReceipt'
                    )
                  "
                >
                  <i class="fas fa-download me-1"></i>
                  Download
                </button>
              </div> -->
            </div>


            <div
              *ngIf="
                enquiry?.statusDescription === 'Order Placed' && accType === '2'
                && getEditedPartsCount() == 0"
                class="section pickup-address mb-4"
            >
              <div class="section-header">
                <i class="fas fa-list-outline"></i>
                <h2>Pickup Details</h2>
              </div>

              <div class="address-card-header mt-3">
                <div class="address-info">
                  <i class="fas fa-map-marker-alt"></i>
                  <div class="address-text">
                    <h5>
                      {{
                        selectedAddress?.address
                          ? "Pickup Address:"
                          : "Select Pickup Location"
                      }}
                    </h5>
                    <p *ngIf="selectedAddress?.address">
                      {{ selectedAddress.address }}, {{ selectedAddress.city }},  
                      {{ selectedAddress.state }}, {{ selectedAddress.zipcode }}
                    </p>
                  </div>
                </div>
                <button class="btn btn-icon" (click)="showAddressModal()">
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>

              <!-- <div class="px-3 pb-3 mt-3">
                <div
                  *ngIf="serviceError"
                  class="alert alert-danger d-flex align-items-center"
                >
                  <i class="fas fa-exclamation-circle me-2"></i>
                  <span>{{ serviceError }}</span>
                </div>
              </div> -->

              <!-- <div
                *ngIf="basicDetails?.enquiryDetails?.serviceDetails?.[0]?.porterService == 1 && isServiceable"
                class="form-group vehicle-type-select mt-3"
              >
                <label for="vehicleType" class="form-label fw-bold"
                  >🚚 Select Vehicle Type</label
                >
                <select
                  class="form-control stylish-select"
                  id="vehicleType"
                  formControlName="vehicleType"
                >
                  <option value="" disabled selected>Select vehicle</option>
                  <option
                    *ngFor="let vehicle of vehicleTypeList"
                    [value]="vehicle.id"
                  >
                    {{ vehicle.label }} — {{ vehicle.capacity }}
                  </option>
                </select>
              </div> -->
            </div>

            <!-- <div
              class="section orderDetails modern-card"
              *ngIf="enquiry?.statusDescription == 'Estimate Sent' && accType == '2'">
              <div class="section-header">
                <i class="fas fa-shopping-cart"></i>
                <h2>Order Details</h2>
              </div>

              
              <div class="detail-card mb-3">
                <div class="detail-row">
                  <div class="detail-label">
                    <i class="fas fa-wallet me-2 text-success"></i>
                    <span>Total Amount</span>
                  </div>
                  <div class="detail-value">
                    <div class="amount-wrapper">
                      <span class="main-price">
                        {{ getCalculatedTotalAmount() | currency:'INR':'symbol':'1.0-0' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

          <!-- order Details Section -->
            <div
              class="section orderDetails modern-card"
              *ngIf="
                (enquiry?.statusDescription == 'Estimate received' ||
                enquiry?.statusDescription == 'Estimate Sent' ||
                enquiry?.statusDescription == 'Estimate Partially Received' ||
                enquiry?.statusDescription == 'Estimate Partially Sent'
                ) && accType == '1'
              "
            >
              <div class="section-header">
                <i class="fas fa-shopping-cart"></i>
                <h2>Order Details</h2>
              </div>

              <!-- Total Amount Card -->
              <div class="detail-card mb-3" *ngIf="accType == '1'">
                <div class="detail-row">
                  <div class="detail-label">
                    <i class="fas fa-wallet me-2 text-success"></i>
                    <span>Total Amount</span>
                  </div>
                  <div class="detail-value">
                    <div class="amount-wrapper">
                      <span class="main-price">
                        {{ totalAmount | currency:'INR':'symbol':'1.0-0' }}
                      </span>
                      <div class="savings-badge" *ngIf="totalSavings > 0">
                        <i class="fas fa-gift"></i>
                        You saved {{ totalSavings | currency:'INR':'symbol':'1.0-0' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- PO Number Upload Card -->
              <div class="upload-section-card" *ngIf="accType == '1'">
                <h6 class="upload-title">
                  <i class="fas fa-file-alt me-2"></i>
                  Purchase Order Details
                </h6>
                <div class="upload-controls">
                  <!-- <input
                    type="text"
                    class="form-control modern-input"
                    placeholder="Enter PO Number"
                    formControlName="poNo"
                  /> -->
                  <button
                    class="btn btn-primary upload-btn"
                    (click)="poUpload()"
                  >
                    <i class="fas fa-upload me-2"></i>
                    Upload PO
                  </button>
                </div>
              </div>

              <!-- Uploaded PO Document Card -->
              <div
                class="doc-card"
                *ngIf="
                  basicDetails?.enquiryDetails?.PoDoc &&
                  basicDetails?.enquiryDetails?.PoDocId
                "
              >
                <div class="doc-icon">
                  <i class="fas fa-file-pdf"></i>
                </div>
                <div class="doc-info">
                  <h6>PO Document</h6>
                  <small>{{ basicDetails?.enquiryDetails?.poNo }}</small>
                </div>
                <div class="doc-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary rounded-pill me-2"
                    (click)="
                      viewPdf(
                        basicDetails?.enquiryDetails?.PoDoc,
                        basicDetails?.enquiryDetails?.poNo
                      )
                    "
                  >
                    <i class="fas fa-download me-1"></i>
                    Download
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger rounded-pill"
                    (click)="
                      deleteAttachment(
                        basicDetails?.enquiryDetails?.PoDocId,
                        1
                      )
                    "
                  >
                    <i class="fas fa-trash me-1"></i>
                    Delete
                  </button>
                </div>
              </div>
            </div>

            <div
              *ngIf="
                (enquiry?.statusDescription ==
                  'Dispatch Confirmation Pending' ||
                  enquiry?.statusDescription == 'Billed/intrasit' ||
                  enquiry?.statusDescription == 'Billed/Delivered' ||
                  enquiry?.statusDescription == 'Pickup in progress' ||
                  enquiry?.statusDescription == 'Pending For POD Approval') &&
                accType == '2'
              "
              class="section pickup-person-section mb-4"
            >
              <div class="section-header">
                <i class="fas fa-person"></i>
                <h2>Pickup Details</h2>
              </div>
              <div class="section-body p-3">
                <div class="row mb-2">
                  <div class="col-3 fw-semibold">📍 Pickup Address</div>
                  <div class="col-9">
                    {{ basicDetails?.enquiryDetails?.pickupAddress || "-" }}
                  </div>
                </div>

                 <!-- Show vehicle type name when deliveryType = '1' and status is NOT 'Dispatch Confirmation Pending' -->
              <div class="row mb-2" *ngIf="basicDetails.enquiryDetails.deliveryType == '1' && enquiry?.statusDescription !== 'Dispatch Confirmation Pending'  && enquiry?.statusDescription !== 'Billed/intrasit'"
                  >
                 <div class="col-3 fw-semibold">🚚 Vehicle Type</div>
                  <div class="col-9">
                    {{ basicDetails?.enquiryDetails?.vehicleTypeName || "-" }}
                  </div>
              </div>

              <!-- Show select list when status is Dispatch Confirmation Pending AND deliveryType = '1' -->
              <div *ngIf="enquiry?.statusDescription == 'Dispatch Confirmation Pending' && basicDetails?.enquiryDetails.deliveryType == '1'"
                  class="form-group vehicle-type-select mb-2">
                <label for="vehicleType" class="form-label fw-bold"
                  >🚚 Select Vehicle Type</label
                >
                <select
                  class="form-control stylish-select"
                  id="vehicleType"
                  formControlName="vehicleType"
                >
                  <option value="" disabled selected>Select vehicle</option>
                  <option
                    *ngFor="let vehicle of vehicleTypeList"
                    [value]="vehicle.id"
                  >
                    {{ vehicle.label }} — {{ vehicle.capacity }}
                  </option>
                </select>

              </div>
              </div>
            </div>

            <div
              *ngIf="
                enquiry?.statusDescription == 'Billed/intrasit' &&
                accType == '1' &&
                basicDetails.enquiryDetails.deliveryType == '2'
              "
              class="section pickup-person-section mb-4"
            >
              <div class="section-header">
                <i class="fas fa-person"></i>
                <h2>Pickup Person Details</h2>
              </div>
              <div class="section-body p-3">
                <div class="row mb-2">
                  <div class="col-4 fw-semibold">Name</div>
                  <div class="col-8">
                    {{
                      basicDetails.enquiryDetails.sellerDetails.seller_name ||
                        "-"
                    }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 fw-semibold">City</div>
                  <div class="col-8">
                    {{ basicDetails.enquiryDetails.sellerDetails.city || "-" }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-4 fw-semibold">Pincode</div>
                  <div class="col-8">
                    {{
                      basicDetails.enquiryDetails.sellerDetails.pincode || "-"
                    }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 fw-semibold">Address</div>
                  <div class="col-8">
                    {{
                      basicDetails.enquiryDetails.sellerDetails.address || "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="
                enquiry?.statusDescription == 'Billed/intrasit' &&
                accType == '1' &&
                basicDetails.enquiryDetails.deliveryType == '2' &&
                basicDetails.enquiryDetails.otpValue
              "
              class="section otp-box-section mb-4"
            >
              <div class="section-body p-3 text-center">
                <i class="fas fa-key fs-2 mb-2"></i><br />
                <span class="h3">{{
                  basicDetails.enquiryDetails.otpValue
                }}</span>
                <p class="mt-2">
                  Share this OTP with the person to receive the product.
                </p>
              </div>
            </div>

            <ng-container
              *ngIf="
                enquiry?.statusDescription == 'Billed/intrasit' &&
                accType == '1' &&
                basicDetails?.enquiryDetails?.deliveryType == '1'
              "
            >
              <div
                *ngIf="hasDeliveryInfo(); else noDeliveryInfo"
                class="card mb-3 delivery-card"
              >
                <div class="card-header bg-light d-flex align-items-center">
                  <i class="fas fa-user me-2"></i>
                  <h5 class="mb-0">Delivery Person Details</h5>
                </div>
                <div class="card-body">
                  <p>
                    <strong>Name:</strong>
                    {{
                      basicDetails.enquiryDetails.deliveryPersonDetails[0]?.name
                    }}
                  </p>
                  <p>
                    <strong>Contact:</strong>
                    {{
                      basicDetails.enquiryDetails.deliveryPersonDetails[0]
                        ?.phoneNo
                    }}
                  </p>
                  <p>
                    <strong>Vehicle No:</strong>
                    {{
                      basicDetails.enquiryDetails.deliveryPersonDetails[0]
                        ?.vehicleNo
                    }}
                  </p>
                </div>
              </div>

              <ng-template #noDeliveryInfo>
                <div class="card mb-3 delivery-card placeholder-card">
                  <div class="card-body">
                    <p class="mb-1">No delivery person assigned yet.</p>
                    <small
                      >Please wait while we assign someone to deliver your
                      order.</small
                    >
                  </div>
                </div>
              </ng-template>
            </ng-container>

            <div
              *ngIf="
                enquiry?.statusDescription == 'Billed/intrasit' &&
                accType == '1' &&
                basicDetails?.enquiryDetails?.deliveryType == '3'
              "
            >
              <div
                *ngIf="
                  basicDetails.enquiryDetails.podId &&
                    basicDetails.enquiryDetails.podDoc;
                  else pendingDispatch
                "
                class="card status-card dispatched mb-3"
              >
                <div class="card-body d-flex align-items-center">
                  <i class="fas fa-check-circle me-2 text-success"></i>
                  <span
                    ><strong>Order Status:</strong> Dispatched – On the way
                    🚚</span
                  >
                </div>
              </div>
              <ng-template #pendingDispatch>
                <div class="card status-card pending mb-3">
                  <div class="card-body d-flex align-items-center">
                    <i class="fas fa-clock me-2 text-warning"></i>
                    <span
                      ><strong>Order Status:</strong> Your order is pending for
                      dispatch.</span
                    >
                  </div>
                </div>
              </ng-template>
            </div>

            <div
              *ngIf="
                ((enquiry?.statusDescription == 'Billed/intrasit' &&
                  basicDetails?.enquiryDetails?.deliveryType == '2') ||
                  (enquiry?.statusDescription == 'Pickup in progress' &&
                    basicDetails?.enquiryDetails?.deliveryType == '1')) &&
                accType == '2' &&
                basicDetails?.enquiryDetails?.otpValue &&
                !basicDetails.enquiryDetails.isOtpVerified
              "
              class="section seller-otp-section mb-4"
            >
              <div class="section-header">
                <i class="fas fa-key"></i>
                <h2>Enter OTP to Confirm</h2>
              </div>
              <div class="section-body p-3">
                <p class="text-muted text-center">
                  The buyer has shared an OTP—please enter the 6‑digit code to
                  confirm delivery.
                </p>

                <ng-otp-input
                  formControlName="otp"
                  [config]="otpConfig"
                ></ng-otp-input>
                <button
                  class="btn btn-success w-100 mt-3"
                  (click)="
                    verifyOtp(basicDetails?.enquiryDetails?.deliveryType)
                  "
                  [disabled]="isLoading"
                >
                  Verify OTP
                </button>
              </div>
            </div>

            <!-- <div
            *ngIf="
              enquiry?.statusDescription == 'Pending For POD Approval' &&
              accType == '2' &&
              basicDetails.enquiryDetails.deliveryType == '3'
            "
            class="section courier-process-section mb-4"
          >
            <div class="section-header">
              <i class="fas fa-receipt"></i>
              <h2>Courier Process</h2>
            </div>
            <div class="section-body p-3">
              <p>1. Download the invoice<br>2. Attach it to your courier<br>3. Upload the POD copy once dispatched</p>
              <div class="d-flex align-items-center mb-3">
                <i class="fas fa-file-invoice me-2"></i>
                <span class="flex-grow-1">Azeapp Invoice</span>
                <i class="fas fa-download cursor-pointer" (click)="viewPdf(basicDetails.enquiryDetails.generatedInvoice, 'azeappinvoice')"></i>
              </div>

              <div *ngIf="podDoc.url; else uploadSection">
                <div class="d-flex align-items-center">
                  <i class="fas fa-paperclip me-2"></i>
                  <span class="flex-grow-1">POD Copy</span>
                  <i class="fas fa-eye cursor-pointer me-2" (click)="viewPdf(podDoc.url, 'podcopy')"></i>
                  <i class="fas fa-trash cursor-pointer" (click)="deletePOD()"></i>
                </div>
              </div>
              <ng-template #uploadSection>
                <button class="btn btn-primary w-100" (click)="uploadPOD()">
                  <i class="fas fa-cloud-upload-alt me-1"></i> Upload POD
                </button>
              </ng-template>
            </div>
          </div> -->

            <div
              *ngIf="
                enquiry?.statusDescription == 'Pending For POD Approval' &&
                accType == '2' &&
                basicDetails.enquiryDetails.deliveryType == '3'
              "
              class="section courier-process mb-4"
            >
              <div class="section-header">
                <i class="fas fa-receipt me-2"></i>
                <h2>Courier Process</h2>
              </div>
              <div class="section-body">
                <!-- <ol class="stepper mb-3">
                <li>Download invoice</li>
                <li>Attach to courier</li>
                <li>Upload POD</li>
              </ol>

              <button class="btn btn-outline-secondary me-2" (click)="viewPdf(basicDetails.enquiryDetails.generatedInvoice, 'azeappinvoice')">
                <i class="fas fa-file-invoice me-1"></i> Download Invoice
              </button>

              <ng-container *ngIf="podDoc.url; else uploadZone">
                <div class="file-card d-flex align-items-center mt-3">
                  <i class="fas fa-paperclip me-2"></i>
                  <span class="flex-grow-1">POD Copy</span>
                  <i class="fas fa-eye me-2 cursor-pointer" (click)="viewPdf(podDoc.url, 'podcopy')"></i>
                  <i class="fas fa-trash cursor-pointer" (click)="deletePOD()"></i>
                </div>
              </ng-container>

              <ng-template #uploadZone>
                <label class="upload-zone mt-3">
                  <i class="fas fa-cloud-upload-alt fa-2x"></i>
                  <button class="btn btn-primary w-100" (click)="uploadPOD()">
                  <i class="fas fa-cloud-upload-alt me-1"></i> Upload POD
                </button>
                </label>
              </ng-template> -->

                <ol class="stepper mb-3">
                  <li>Download invoice</li>
                  <li>Attach to courier</li>
                  <li>Upload POD</li>
                </ol>

                <!-- Download Invoice CTA -->
                <button
                  class="btn-secondary-outline me-2"
                  (click)="
                    viewPdf(
                      basicDetails.enquiryDetails.generatedInvoice,
                      'azeappinvoice'
                    )
                  "
                >
                  <i class="fas fa-file-invoice me-1"></i> Download Invoice
                </button>

                <!-- Upload POD Zone -->
                <ng-container *ngIf="podDoc.url; else uploadZone">
                  <div class="file-card d-flex align-items-center mt-3">
                    <i class="fas fa-paperclip me-2"></i>
                    <span class="flex-grow-1">POD Copy</span>
                    <i
                      class="fas fa-eye me-2 cursor-pointer"
                      (click)="viewPdf(podDoc.url, 'podcopy')"
                    ></i>
                    <i
                      class="fas fa-trash cursor-pointer"
                      (click)="deletePOD()"
                    ></i>
                  </div>
                </ng-container>

                <ng-template #uploadZone>
                  <div class="upload-zone">
                    <i class="fas fa-cloud-upload-alt fa-2x mb-2"></i>
                    <div>Click or drag file here to upload POD</div>
                    <button
                      class="btn btn-primary-solid w-100 mt-2"
                      (click)="uploadPOD()"
                    >
                      <i class="fas fa-cloud-upload-alt me-1"></i> Upload POD
                    </button>
                  </div>
                </ng-template>
              </div>
            </div>

            <ng-container
              *ngIf="
                [
                  'Return Raised',
                  'Pending For Return Approval',
                  'Return Approved'
                ].includes(enquiry?.statusDescription)
              "
            >
              <div
                class="section partDetails"
                *ngFor="
                  let returnDetail of basicDetails?.enquiryDetails
                    ?.returnDetails
                "
              >
                <div
                  class="section-header"
                  *ngIf="returnDetail.type === 'Qty Wise'"
                >
                  <i class="fas fa-cogs"></i>
                  <h2>Return Part Details (Product Return)</h2>
                </div>
                <div
                  class="section-header"
                  *ngIf="returnDetail.type === 'Amount Wise'"
                >
                  <i class="fas fa-cogs"></i>
                  <h2>Return Details (Non-Product Return)</h2>
                </div>

                <div class="table-responsive">
                  <div class="row font-weight-bold border-bottom py-2 bg-light">
                    <div
                      *ngIf="returnDetail.type === 'Qty Wise'"
                      class="col-3 text-center"
                    >
                      Part No
                    </div>
                    <div
                      class="col text-center"
                      [ngClass]="
                        returnDetail.type === 'Qty Wise' ? 'col-4' : 'col-8'
                      "
                    >
                      Description
                    </div>
                    <div
                      *ngIf="returnDetail.type === 'Qty Wise'"
                      class="col-3 text-center"
                    >
                      Return Qty
                    </div>
                    <div
                      *ngIf="returnDetail.type === 'Qty Wise'"
                      class="col-2 text-center"
                    >
                      Opt
                    </div>
                    <div
                      *ngIf="returnDetail.type === 'Amount Wise'"
                      class="col-2 text-center"
                    >
                      Return Amount
                    </div>
                  </div>

                  <ng-container
                    *ngFor="
                      let part of returnDetail.partDetetails;
                      let i = index
                    "
                  >
                    <div class="row py-2 align-items-center border-bottom">
                      <ng-container *ngIf="returnDetail.type === 'Qty Wise'">
                        <div class="col-3 text-center">
                          <span class="highlight medium">{{
                            part?.partNo || "-"
                          }}</span>
                        </div>
                        <div class="col-4 text-center">
                          <span class="highlight large">{{
                            part?.description
                          }}</span>
                        </div>
                        <div class="col-3 text-center">
                          <span class="highlight small">{{
                            part?.return_qty
                          }}</span>
                        </div>
                        <div class="col-2 text-center">
                          <i
                            class="fas fa-eye"
                            [style.color]="part.url ? 'blue' : 'gray'"
                            [style.cursor]="
                              part.url ? 'pointer' : 'not-allowed'
                            "
                            (click)="
                              part.url
                                ? showReturnPartDetailsAttachment(i, part)
                                : null
                            "
                          >
                          </i>
                        </div>

                        <div class="col-9 text-muted text-center">Remarks</div>
                        <div class="col-3 text-muted text-center">Action</div>

                        <div class="col-9 text-center">
                          <span class="highlight large">{{
                            part?.remarks || "-"
                          }}</span>
                        </div>
                        <div class="col-3 text-center">
                          <ng-container
                            *ngIf="
                              enquiry?.statusDescription === 'Return Raised'
                            "
                          >
                            <ng-container *ngIf="accType == '2'; else noAction">
                              <input
                                type="checkbox"
                                [checked]="isReturnSelected(part?.id)"
                                (change)="
                                  onReturnCheckboxChange(part?.id, $event)
                                "
                              />
                            </ng-container>
                            <ng-template #noAction> - </ng-template>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              enquiry?.statusDescription === 'Return Approved'
                            "
                          >
                            <i
                              class="fas fa-check-circle text-success"
                              title="Approved"
                            ></i>
                          </ng-container>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="returnDetail.type === 'Amount Wise'">
                        <div class="col-8 text-center">
                          <span class="highlight large">{{
                            part?.description
                          }}</span>
                        </div>
                        <div class="col-4 text-center">
                          ₹ {{ part?.return_price || "0.00" }}
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>

                <!-- Upload Form: No debit note yet -->
                <div
                  class="row mb-2"
                  *ngIf="
                    accType == '2' &&
                    isAnyReturnSelected() &&
                    !returnDetail.debitnoteNo &&
                    !returnDetail.docpath
                  "
                >
                  <ng-container *ngIf="!debitNote.id">
                    <div class="col-9">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Enter DebitNote No"
                        [(ngModel)]="debitNote.no"
                        [ngModelOptions]="{ standalone: true }"
                        name="debitNoteNo"
                      />
                    </div>
                    <div class="col-3">
                      <button
                        class="btn btn-primary w-100"
                        (click)="dnUpload()"
                        [disabled]="!debitNote.no || debitNote.no.trim() === ''"
                      >
                        Upload
                      </button>
                    </div>
                  </ng-container>

                  <!-- Debit note info (after upload) -->
                  <ng-container *ngIf="debitNote.id && accType == '2'">
                    <div class="col-12 mt-2">
                      <div>
                        <strong>Debit Note No:</strong>
                        {{ debitNote.no || "-" }}
                      </div>
                      <div class="mt-1">
                        <strong>Document:</strong>
                        <i
                          class="fas fa-file-download text-primary cursor-pointer ms-2"
                          (click)="viewPdf(debitNote.url, debitNote.no)"
                        ></i>
                      </div>
                    </div>
                  </ng-container>
                </div>

                <!-- Already Uploaded Debit Note -->
                <div
                  class="row mt-2"
                  *ngIf="
                    (returnDetail.debitnoteNo || returnDetail.docpath) &&
                    accType == '2'
                  "
                >
                  <div class="col-12">
                    <div>
                      <strong>Debit Note No:</strong>
                      {{ returnDetail.debitnoteNo || "-" }}
                    </div>
                    <div class="mt-1">
                      <strong>Document:</strong>
                      <i
                        class="fas fa-file-download text-primary cursor-pointer ms-2"
                        (click)="
                          viewPdf(
                            returnDetail.docpath,
                            returnDetail.debitnoteNo
                          )
                        "
                      ></i>
                    </div>
                  </div>
                </div>

                <!-- Approved Return Invoice for Buyer -->
                <div
                  class="row mt-2"
                  *ngIf="
                    returnDetail.invPath &&
                    accType == '1' &&
                    enquiry?.statusDescription == 'Return Approved'
                  "
                >
                  <div class="col-12">
                    <div>
                      <strong>Document:</strong>
                      <i
                        class="fas fa-file-download text-primary cursor-pointer ms-2"
                        (click)="
                          viewPdf(returnDetail.invPath, returnDetail.prNo)
                        "
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </form>

          <ng-container
            *ngIf="
              enquiry?.statusDescription == 'Additional info required' &&
              accType == '2'
            "
          >
            <ng-container
              *ngIf="
                Object.keys(partPriceList).length > 0;
                else notAvailableBlock
              "
            >
              <div class="footActions">
                <button
                  class="btn btn-primary w-100"
                  type="button"
                  (click)="AddInfoReqSubmitBySeller()"
                  [disabled]="isLoading"
                >
                  <span
                    *ngIf="isLoading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submit
                </button>
              </div>
            </ng-container>

            <ng-template #notAvailableBlock>
              <div class="footActions">
                <button
                  class="btn btn-danger w-100"
                  type="button"
                  (click)="onEnqRemainNotAvailable()"
                  [disabled]="isLoading"
                >
                  <span *ngIf="!isLoading" class="me-2">
                    <i class="fas fa-times-circle"></i>
                  </span>

                  <span
                    *ngIf="isLoading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>

                  Remaining Parts Not Available
                </button>
              </div>
            </ng-template>
          </ng-container>

          <!-- Submit Button for Estimate Received -->
          <div
            class="footActions"
            *ngIf="enquiry?.statusDescription == 'Estimate received'"
          >
            <button
              class="btn btn-primary w-100"
              type="button"
              (click)="onEstimateSubmit()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Submit
            </button>
          </div>

          <!-- Submit Button for Order Placed (accType 2) -->
          <div
            class="footActions"
            *ngIf="
              enquiry?.statusDescription == 'Order Placed' && accType == '2'
            "
          >
            <!-- <button
              class="btn btn-primary w-100"
              type="button"
              (click)="OnOrderSubmit()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Submit
            </button> -->
             <!-- If there are edited parts, show Submit All Changes button -->
            <ng-container *ngIf="getEditedPartsCount() > 0; else normalSubmit">
              <button
                class="btn btn-primary w-100"
                type="button"
                (click)="submitAllEditedParts()"
                [disabled]="isLoading"
              >
                <span
                  *ngIf="isLoading"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i class="fas fa-save me-2"></i>
                Submit All Changes ({{ getEditedPartsCount() }})
              </button>
            </ng-container>

            <!-- If no edited parts, show normal Submit button -->
            <ng-template #normalSubmit>
              <button
                class="btn btn-primary w-100"
                type="button"
                (click)="OnOrderSubmit()"
                [disabled]="isLoading"
              >
                <span
                  *ngIf="isLoading"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Submit
              </button>
            </ng-template>
          </div>

          <div
            class="footActions"
            *ngIf="
              enquiry?.statusDescription == 'Pending For POD Approval' &&
              accType == '2' &&
              basicDetails?.enquiryDetails?.deliveryType == '3'
            "
          >
            <button
              class="btn btn-primary w-100"
              type="button"
              (click)="onPodSubmit()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Submit
            </button>
          </div>

          <div
            class="footActions"
            *ngIf="
              enquiry?.statusDescription == 'Billed/intrasit' &&
              accType == '1' &&
              ((basicDetails?.enquiryDetails?.deliveryType == '3' &&
                basicDetails?.enquiryDetails?.podId) ||
                (basicDetails?.enquiryDetails?.deliveryType == '1' &&
                  basicDetails?.enquiryDetails?.isOtpVerified))
            "
          >
            <button
              class="btn btn-primary w-100"
              type="button"
              (click)="OnReceiveSubmit()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Received
            </button>
          </div>

          <div
            class="footActions"
            *ngIf="
              enquiry?.statusDescription == 'Dispatch Confirmation Pending' &&
              accType == '2' &&
              basicDetails?.enquiryDetails?.deliveryType == '1'
            "
          >
            <button
              class="btn btn-primary w-100"
              type="button"
              (click)="confirmDispatch()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Dispatch
            </button>
          </div>

          <!-- For Buyer: Show "Purchase Return Make" button -->
          <div
            class="footActions mt-3"
            *ngIf="
              enquiry?.statusDescription === 'Billed/Delivered' &&
              accType == '1'
            "
          >
            <button
              class="btn btn-danger w-100"
              type="button"
              (click)="OnPurchaseReturnMake()"
            >
              Purchase Return Make
            </button>
          </div>

          <!-- For Seller: Show Approve or Reject based on selection -->
          <div
            class="footActions mt-3"
            *ngIf="
              enquiry?.statusDescription === 'Return Raised' && accType == '2'
            "
          >
            <!-- Approve button: when return selected -->
            <button
              *ngIf="isAnyReturnSelected()"
              class="btn btn-success w-100 d-flex align-items-center justify-content-center"
              type="button"
              (click)="OnReturnSubmit()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Approve
            </button>

            <!-- Reject button: when no return selected -->
            <button
              *ngIf="!isAnyReturnSelected()"
              class="btn btn-danger w-100 d-flex align-items-center justify-content-center"
              type="button"
              (click)="onReturnReject()"
              [disabled]="isLoading"
            >
              <span
                *ngIf="isLoading"
                class="spinner-border spinner-border-sm me-2"
                role="status"
              ></span>
              Reject
            </button>
          </div>

          <ng-container *ngIf="enquiry?.statusDescription == 'New Enquiry'">
            <ng-container
              *ngIf="
                Object.keys(this.partPriceList).length > 0;
                else notAvailableBlock
              "
            >
              <div class="footActions">
                <button
                  class="btn btn-primary w-100"
                  type="button"
                  (click)="onEnqPriceSubmit(1)"
                  [disabled]="isLoading"
                >
                  <span
                    *ngIf="isLoading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submit
                </button>
              </div>
            </ng-container>

            <ng-template #notAvailableBlock>
              <div class="footActions">
                <button
                  class="btn btn-danger w-100"
                  type="button"
                  (click)="onEnqRemainNotAvailable()"
                  [disabled]="isLoading"
                >
                  <i
                    *ngIf="!isLoading"
                    class="fas fa-times-circle me-2"
                    aria-hidden="true"
                  ></i>
                  <span
                    *ngIf="isLoading"
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Remaining Parts Not Available
                </button>
              </div>
            </ng-template>

            <div class="section queryDetails" *ngIf="querys?.length > 0">
              <div class="section-header">
                <i class="fas fa-info-circle"></i>
                <h2>Query Details</h2>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th scope="col" style="width: 40%">Type</th>
                      <th scope="col" style="width: 50%">Remarks</th>
                      <th scope="col" style="width: 10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let query of querys; let i = index">
                      <td>{{ getQuerlyValue(query?.queryType) || "N/A" }}</td>
                      <td>{{ query?.remark || "No remarks" }}</td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-link text-danger p-0"
                          (click)="removeQuery(i)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!orderAvailable">
        <app-order-placed></app-order-placed>
      </ng-container>
    </div>

    <!-- Modal -->
    <div
      class="modal fade show d-block selectQueryModal"
      tabindex="-1"
      role="dialog"
      [ngClass]="{ 'd-none': !showQueryModal }"
      style="background: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <form [formGroup]="QueryForm">
            <div class="modal-header">
              <h5 class="modal-title">Queries</h5>
              <button
                type="button"
                class="btn-close"
                aria-label="Close"
                (click)="showQueryModal = false"
              ></button>
            </div>

            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label"
                  ><i class="fas fa-info-circle me-1"></i>New Query</label
                >
                <select
                  class="form-select"
                  formControlName="type"
                  (change)="onQueryTypeChange($event)"
                >
                  <option value="" disabled selected>Select Query</option>
                  <option *ngFor="let item of queryList" [value]="item.id">
                    {{ item.value }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <textarea
                  class="form-control"
                  placeholder="Enter your remarks"
                  formControlName="remarks"
                  rows="3"
                ></textarea>
              </div>

              <div class="mb-3 text-end">
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  (click)="addQuery()"
                  [disabled]="isLoading"
                >
                  <i class="fas fa-plus me-1"></i>
                  Add Query
                  <span
                    *ngIf="isLoading"
                    class="spinner-border spinner-border-sm ms-2"
                    role="status"
                  ></span>
                </button>
              </div>

              <div *ngIf="querys?.length > 0" class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th scope="col" style="width: 40%">Type</th>
                      <th scope="col" style="width: 50%">Remarks</th>
                      <th scope="col" style="width: 10%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let query of querys; let i = index">
                      <td>
                        {{
                          query?.type
                            ? query?.type
                            : getQuerlyValue(query?.queryType) || "N/A"
                        }}
                      </td>
                      <td>{{ query?.remark || "No remarks" }}</td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-link text-danger p-0"
                          (click)="removeQuery(i)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="modal-footer">
              <button
                class="btn btn-primary w-100"
                type="button"
                (click)="onEnqPriceSubmit(2)"
                [disabled]="isLoading || !querys?.length"
              >
                <span
                  *ngIf="isLoading"
                  class="spinner-border spinner-border-sm me-2"
                  role="status"
                ></span>
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="error-overlay" *ngIf="showErrorBanner">
    <div class="error-box">
      <span class="icon">⚠️</span>
      <span class="message">Something went wrong. Please try again later.</span>
      <button class="close-btn" (click)="handleErrorClose()">OK</button>
    </div>
  </div> -->
</div>

<ng-template #excelPreviewModal let-modal>
  <form
    #excelForm="ngForm"
    (ngSubmit)="confirmExcelData(excelForm, modal)"
    novalidate
  >
    <div class="modal-header">
      <h5 class="modal-title">Preview Excel Data</h5>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <div class="modal-body">
      <div class="table-responsive">
        <table
          class="table table-bordered table-sm table-striped table-hover mb-0"
        >
          <thead>
            <tr>
              <th>Part No</th>
              <th>Description</th>
              <th>Qty</th>
              <th *ngIf="columns.includes('OE(MRP)')">OE (MRP)</th>
              <th *ngIf="columns.includes('OES Brand')">OES Brand</th>
              <th *ngIf="columns.includes('OES(MRP)')">OES (MRP)</th>
              <th *ngIf="columns.includes('IMP(Landing Price)')">IMP Price</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of excelPreview; let i = index">
              <td>{{ row.partNo }}</td>
              <td>{{ row.partDescription }}</td>
              <td>{{ row.qty }}</td>

              <!-- <td>
                <input [(ngModel)]="row.partDescription" name="desc{{i}}"
                       class="form-control" required />
                <div class="text-danger small"
                     *ngIf="excelForm.submitted && !row.partDescription">
                  Description is required
                </div>
              </td>

              <td>
                <input type="number" [(ngModel)]="row.qty" name="qty{{i}}"
                       class="form-control" required />
                <div class="text-danger small"
                     *ngIf="excelForm.submitted && isInvalidQty(row.qty)">
                  Qty is required and must be valid
                </div>
              </td> -->

              <td *ngIf="columns.includes('OE(MRP)')">
                <input
                  type="number"
                  [(ngModel)]="row.oeMrp"
                  name="oeMrp{{ i }}"
                  class="form-control"
                />
              </td>

              <td *ngIf="columns.includes('OES Brand')">
                <input
                  type="text"
                  [(ngModel)]="row.oesBrand"
                  name="oesBrand{{ i }}"
                  class="form-control"
                />
              </td>

              <td *ngIf="columns.includes('OES(MRP)')">
                <input
                  type="number"
                  [(ngModel)]="row.oesMrp"
                  name="oesMrp{{ i }}"
                  class="form-control"
                />
              </td>

              <td *ngIf="columns.includes('IMP(Landing Price)')">
                <input
                  type="number"
                  [(ngModel)]="row.impLandingPrice"
                  name="impLandingPrice{{ i }}"
                  class="form-control"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary">Confirm & Patch</button>
    </div>
  </form>
</ng-template>

<div
  *ngIf="
    ['Return Raised', 'Pending For Return Approval'].includes(
      enquiry?.statusDescription
    )
  "
  class="fab-container"
>
  <button class="fab-button" (click)="openChatModal()">💬</button>
</div>

<!-- Edit Part Modal -->
<ng-template #editPartModal let-modal>
  <div class="modal-header gradient-header">
    <h5 class="modal-title">
      <i class="fas fa-edit me-2"></i>
      Edit Part Details
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <form [formGroup]="editPartForm" *ngIf="selectedPart">
      <!-- Part No with Autocomplete -->
      <div class="form-group mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label"><strong>Part No</strong></label>
          <small class="text-muted">Current: {{ selectedPart?.partNo }}</small>
        </div>
        
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            formControlName="partNo"
            placeholder="Enter Part No (min 3 characters)"
            (input)="onPartNoInput($event)"
            (blur)="hideSuggestions()"
            (focus)="onPartNoInput($event)"
            autocomplete="off"
          />
          
          <!-- Loading Spinner -->
          <div class="search-loading" *ngIf="partSearchLoading">
            <span class="spinner-border spinner-border-sm"></span>
          </div>

          <!-- Autocomplete Suggestions Dropdown -->
          <div 
            class="autocomplete-suggestions-modal"
            *ngIf="showPartSuggestions && partItemsList.length > 0"
          >
            <div class="suggestion-header">
              <small>{{ partItemsList.length }} results found</small>
            </div>
            <div class="suggestion-items">
              <div
                class="suggestion-item"
                *ngFor="let item of partItemsList"
                (mousedown)="selectPartItem(item); $event.preventDefault(); $event.stopPropagation()"
                (touchstart)="selectPartItem(item); $event.preventDefault(); $event.stopPropagation()"
              >
                <div class="item-main">
                  <strong>{{ item.part_no || item.name }}</strong>
                </div>
                <small class="item-desc">{{ item.partDescription || item.description }}</small>
              </div>
            </div>
          </div>

          <!-- No Results Message -->
          <div 
            class="autocomplete-no-results"
            *ngIf="showPartSuggestions && partItemsList.length === 0 && !partSearchLoading"
          >
            <small>No parts found matching your search</small>
          </div>
        </div>
      </div>

      <!-- Part Description -->
      <div class="form-group mb-3">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <label class="form-label"><strong>Part Description</strong></label>
          <small class="text-muted">Current: {{ selectedPart?.partDescription }}</small>
        </div>
        <textarea
          class="form-control"
          formControlName="partDescription"
          placeholder="Enter Part Description"
          rows="2"
        ></textarea>
      </div>

      <!-- Quantity -->
      <div class="form-group mb-3">
        <label class="form-label"><strong>Quantity</strong></label>
        <input
          type="number"
          class="form-control"
          formControlName="qty"
          placeholder="Enter Quantity"
          min="1"
        />
      </div>

      <!-- Price -->
      <div class="form-group mb-3">
        <label class="form-label"><strong>Price (INR)</strong></label>
        <input
          type="number"
          class="form-control"
          formControlName="price"
          placeholder="Enter Price"         
        />
      </div>

      <!-- Error Message -->
      <div class="alert alert-danger" *ngIf="editError">
        {{ editError }}
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="modal.dismiss()"
    >
      <i class="fas fa-times me-1"></i>
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="saveEditedPart(modal)"
      [disabled]="!editPartForm.valid || isLoading"
    >
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
      <i class="fas fa-save me-1"></i>
      Save Changes
    </button>
  </div>
</ng-template>

